<template>
	<div style="font-size: 14px; padding: 0px 0px" class="create_project">
		<div v-if="!show_order_page">
			<el-row>
				<span v-for="(item, idx) in createProjectItems" :key="idx">
					<span
						style="margin-right: 40px"
						:style="item.active ? 'font-weight:bold' : ''"
						>{{ item.name }}</span
					>
				</span>
			</el-row>
			<el-card class="mt-3" shadow="never">
				<div v-if="createProjectItems[0].active" class="">
					<div
						style="
							min-height: 69vh;
							max-height: 69vh;
							overflow-y: auto;
							overflow-x: hidden;
						"
					>
						<el-row :gutter="12">
							<el-col :md="3" :xl="3" :xs="24" :sm="24">
								<div>Project Title</div>
							</el-col>
							<el-col :xl="10" :md="10" :xs="10" :sm="10">
								<el-input
									type="text"
									v-model="project_title"
									placeholder="Enter Project Title"
									class="input-class"
									v-validate="'required'"
									name="Project Title"
								/>
								<p>
									<span
										:v-show="errors.has(`Project Title`)"
										class="text-red-dark text-xs"
									>
										{{
											errors.first(`Project Title`)
												? "This field is required"
												: ""
										}}
									</span>
								</p>
							</el-col>
						</el-row>
						<el-row
							class="project-table01"
							style="margin-top: 30px; border-radius: 12px"
						>
							<el-col :span="24">
								<el-table style="border-radius: 8px" :data="tableData">
									<el-table-column width="270" prop="" label="Sr No">
										<template slot-scope="scope">
											<div v-if="scope.row.srno_selection">
												{{ tableData.length }}
											</div>
											<div v-else>
												<el-row>
													<el-col :span="10">
														<div
															@mouseover="show_edit_icon(scope.row)"
															@mouseleave="hide_edit_icon(scope.row)"
														>
															<b
																v-if="!scope.row.showDropdown"
																@mouseleave="hide_edit_icon(scope.row)"
															>
																{{ scope.row.srno }}.
																<img
																	@click="show_dropdown(scope.row)"
																	v-if="scope.row.editable_icon == true"
																	width="14px"
																	class="mr-5"
																	src="../../../assets/icons/EditIcon.png"
																/>
															</b>
															<el-select
																v-if="scope.row.showDropdown"
																style="margin-top: 10px; width: 100%"
																class="select"
																v-model="scope.row.srno"
																filterable
																placeholder="Select"
																@visible-change="
																	change_serial_number(
																		scope.row,
																		scope.row.$index,
																		$event
																	)
																"
															>
																<el-option
																	v-for="(itemxx, key) in serialNumberItems"
																	:key="key"
																	:label="itemxx.name"
																	:value="itemxx.value"
																>
																</el-option>
															</el-select>
														</div>
													</el-col>
													<el-col
														class="ml-2 mt-1"
														v-if="scope.row.showDropdown"
														:span="4"
													>
														<el-button
															@click="
																cancel_change_serial_number(
																	scope.row,
																	scope.$index
																)
															"
															size="mini"
															icon="el-icon-close"
															style="
																border-radius: 12px;
																color: red;
																border-color: red;
															"
														></el-button>
													</el-col>
													<el-col
														class="ml-3 mt-1"
														v-if="scope.row.showDropdown"
														:span="4"
													>
														<el-button
															@click="
																success_change_serial_number(
																	scope.row,
																	scope.$index
																)
															"
															size="mini"
															icon="el-icon-check"
															style="
																border-radius: 12px;
																color: green;
																border-color: green;
															"
														></el-button>
													</el-col>
												</el-row>
											</div>
										</template>
									</el-table-column>
									<el-table-column width="400px" label="Category">
										<template slot-scope="scope">
											<div
												v-if="scope.row.category_selection || scope.row.editing"
											>
												<el-select
													@change="list_forms"
													class="select"
													v-model="category"
													filterable
													placeholder="Select Category"
												>
													<el-option
														v-for="(item, idx) in categoryItems"
														:key="idx"
														:label="item.name"
														:value="item.id"
													>
													</el-option>
												</el-select>
											</div>
											<div v-else>{{ scope.row.category }}</div>
										</template>
									</el-table-column>
									<el-table-column label="Forms">
										<template slot-scope="scope">
											<div v-if="scope.row.form_selection || scope.row.editing">
												<el-select
													@change="all_form_items(scope.$index, scope.row)"
													class="select"
													v-model="form"
													collapse-tags
													filterable
													:clearable="true"
													placeholder="Select Form"
													:multiple="true"
												>
													<el-option
														v-for="(item, idx) in formItems"
														:key="idx"
														:label="item.name"
														:value="item.id"
													>
													</el-option>
												</el-select>
											</div>
											<div v-else>
												<div
													@mouseover="show_edit_icon_form(scope.row)"
													@mouseleave="hide_edit_icon_form(scope.row)"
												>
													<div @mouseleave="hide_edit_icon_form(scope.row)">
														{{ scope.row.form_length }}
														<img
															@click="openDialogForm(scope.row)"
															v-if="scope.row.editable_icon_form == true"
															width="14px"
															class="mr-5"
															src="../../../assets/icons/EditIcon.png"
														/>
													</div>
												</div>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="points" label="Points">
									</el-table-column>
									<!-- <el-table-column label="Critical">
									<template slot-scope="scope">
										<div
											v-if="scope.row.critical_selection || scope.row.editing"
										>
											<el-select
												class="select"
												v-model="critical"
												filterable
												placeholder="Select"
											>
												<el-option
													v-for="(item, idx) in criticalItems"
													:key="idx"
													:label="item.name"
													:value="item.value"
												>
												</el-option>
											</el-select>
										</div>
										<div v-else>{{ scope.row.critical ? "Yes" : "No" }}</div>
									</template>
								</el-table-column> -->
									<el-table-column prop="" label="Allowed On">
										<template slot-scope="scope">
											<div
												v-if="
													scope.row.allowed_on_selection || scope.row.editing
												"
											>
												<el-select
													class="select"
													v-model="allowedOn"
													filterable
													placeholder="Select"
												>
													<el-option
														v-for="(item, idx) in allowedOnItems"
														:key="idx"
														:label="item.name"
														:value="item.value"
													>
													</el-option>
												</el-select>
											</div>
											<div style="text-transform: capitalize" v-else>
												{{ scope.row.allowedon }}
											</div>
										</template>
									</el-table-column>
									<el-table-column>
										<template slot-scope="scope">
											<el-button
												size="mini"
												style="border: none; background-color: transparent"
												@click="
													toggle_actions_edit(
														scope.$index,
														scope.row,
														'EDIT',
														1
													)
												"
												v-if="
													!scope.row.category_selection && !scope.row.editing
												"
											>
												<img
													v-if="!tableEditing"
													src="../../../assets/icons/edit_pencil_icon.png"
													width="10px"
													height="10px"
													alt=""
												/>
											</el-button>
											<el-button
												v-if="!scope.row.category_selection && !tableEditing"
												icon="el-icon-delete"
												size="mini"
												style="border: none; background-color: transparent"
												@click="
													toggle_actions(scope.$index, scope.row, 'DELETE', 1)
												"
											></el-button>
											<el-button
												v-if="scope.row.category_selection || scope.row.editing"
												icon="el-icon-plus"
												size="mini"
												class="button-class-white2"
												style="height: 30px"
												@click="add_more(1, scope.$index, scope.row)"
												>Add</el-button
											>
										</template>
									</el-table-column>
									<el-table-column v-if="tableEditing">
										<template slot-scope="scope">
											<el-button
												v-if="scope.row.editing"
												size="mini"
												style="border: none; background-color: transparent"
												class="button-class-white2"
												@click="
													toggle_actions_cancel(
														scope.$index,
														scope.row,
														'CANCEL',
														1
													)
												"
												>Cancel</el-button
											>
										</template>
									</el-table-column>
								</el-table>
							</el-col>
						</el-row>
						<!-- <el-row
						v-if="tableData.length >= 1 && !tableData[0].category_selection"
						class="project-table00"
						style="margin-top: 5px; border-radius: 12px"
					>
						<el-col :span="24">
							<el-table
								empty-text=""
								style="border-radius: 8px"
								:data="tableData1"
							>
								<el-table-column width="270"> </el-table-column>
								<el-table-column width="400px" label="Total"> </el-table-column>
								<el-table-column>
									<template v-slot:header>
										{{ getTotal }}
									</template>
								</el-table-column>
								<el-table-column>
									<template v-slot:label>
										{{ getPoints() }}
									</template>
								</el-table-column>
								<el-table-column> </el-table-column>
								<el-table-column> </el-table-column>
							</el-table>
						</el-col>
					</el-row> -->
						<el-row
							v-if="tableData.length >= 1 && !tableData[0].category_selection"
							class="project-table00"
							style="margin-top: 5px; border-radius: 12px"
						>
							<el-col :span="24">
								<el-table
									empty-text=""
									style="border-radius: 8px"
									:data="tableData1"
								>
									<el-table-column width="270"> </el-table-column>
									<el-table-column width="400px" label="Total">
									</el-table-column>
									<el-table-column :label="getTotal"> </el-table-column>
									<el-table-column :label="getPoints"> </el-table-column>
									<el-table-column> </el-table-column>
									<el-table-column> </el-table-column>
								</el-table>
							</el-col>
						</el-row>
						<el-row
							v-if="tableData.length >= 1 && !tableData[0].category_selection"
							style="margin-top: 10px"
						>
							<el-col :offset="2">
								<el-button
									class="button-class-white2"
									style="margin-top: 0px"
									icon="el-icon-plus"
									@click="add_more(111)"
								>
									Add More
								</el-button>
							</el-col>
						</el-row>
						<el-row style="margin-top: 20px">
							<el-col :offset="2">
								<div style="font-size: 14px">
									Note:
									<span>
										If any category is marked critical and it Fails, overall
										project will get marked as Fail
									</span>
								</div>
							</el-col>
						</el-row>
					</div>
					<el-row>
						<el-col
							style="margin-top: 10px; margin-right: 20px"
							v-if="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
							"
							:span="2"
							:offset="17"
						>
							<el-button
								@click="go_back()"
								class="button-class-white2"
								style="border: none"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col
							style="margin-top: 10px; margin-right: 0px"
							:span="2"
							:offset="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
									? 0
									: 17
							"
						>
							<el-button @click="go_to_launch()" class="button-class-white2">
								Back
							</el-button>
						</el-col>
						<el-col :span="3" style="margin-top: -30px">
							<el-button @click="nextStep(1)" class="button-class">
								Continue
							</el-button>
						</el-col>
					</el-row>
				</div>
				<div v-if="createProjectItems[1].active">
					<div
						style="
							min-height: 65vh;
							max-height: 65vh;
							overflow-y: auto;
							overflow-x: hidden;
						"
					>
						<el-row style="margin-top: 10px">
							<el-col style="margin-top: 20px" :span="3">
								<div>Validity</div>
							</el-col>
							<el-col :span="4">
								<div style="margin-bottom: 5px">Start Date</div>
								<div>
									<el-date-picker
										v-model="start_date"
										type="date"
										placeholder="Select Date"
										class="date"
										format="yyyy-MM-dd"
										v-validate="'required'"
										name="Start Date"
										:picker-options="datePickerOptions"
									>
									</el-date-picker>
									<p>
										<span
											:v-show="errors.has(`Start Date`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Start Date`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</div>
							</el-col>
							<el-col :span="4" :offset="1">
								<div style="margin-bottom: 5px">End Date</div>
								<div>
									<el-date-picker
										v-model="end_date"
										type="date"
										placeholder="Select Date"
										class="date"
										format="yyyy-MM-dd"
										v-validate="never ? '' : 'required'"
										name="End Date"
										:picker-options="fromDatePickerOptions"
										:disabled="never"
									>
									</el-date-picker>
									<p>
										<span
											:v-show="errors.has(`End Date`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`End Date`) ? "This field is required" : ""
											}}
										</span>
									</p>
								</div>
							</el-col>
							<el-col style="margin-top: 20px" :span="1" :offset="1">
								<el-checkbox label="Never Ends" v-model="never"></el-checkbox>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px">
							<el-col :span="3">
								<div style="margin-top: 20px">Frequency</div>
							</el-col>
							<el-col :span="5">
								<div style="margin-bottom: 5px">Frequency</div>
								<div>
									<el-select
										@change="get_values"
										class="select"
										v-model="frequency"
										filterable
										placeholder="Select Frequency"
										v-validate="'required'"
										name="Select Frequency"
									>
										<el-option
											v-for="(item, key) in frequencyItems"
											:key="key"
											:label="item.name"
											:value="item.value"
										>
										</el-option>
									</el-select>
									<p>
										<span
											:v-show="errors.has(`Select Frequency`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Frequency`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</div>
							</el-col>
							<el-col
								:span="5"
								:offset="1"
								v-if="
									frequency == 'weekly' && weekly_radio == 'anyday_in_the_week'
								"
							>
								<div style="margin-bottom: 5px">Repeat</div>
								<div>
									<el-select
										class="select"
										v-model="repeat"
										filterable
										placeholder="Select Repeat Frequency"
										v-validate="'required'"
										name="Select Repeat Frequency"
									>
										<el-option
											v-for="(item, key) in repeatItems"
											:key="key"
											:label="item.name"
											:value="item.value"
										>
										</el-option>
									</el-select>
									<p>
										<span
											:v-show="errors.has(`Select Repeat Frequency`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Repeat Frequency`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</div>
							</el-col>
							<el-col v-if="frequency == 'monthly'" :span="3" :offset="1">
								<div style="margin-bottom: 5px">Month</div>
								<div>
									<el-select
										class="select"
										v-model="months_selection"
										filterable
										placeholder="Select Month"
										v-validate="'required'"
										name="Select Month"
									>
										<el-option
											v-for="(item, key) in months_selectionItems"
											:key="key"
											:label="item.name"
											:value="item.value"
										>
										</el-option>
									</el-select>
									<p>
										<span
											:v-show="errors.has(`Select Month`)"
											class="text-red-dark text-xs"
										>
											{{
												errors.first(`Select Month`)
													? "This field is required"
													: ""
											}}
										</span>
									</p>
								</div>
							</el-col>
							<el-col
								v-if="
									frequency == 'monthly' && months_selection == 'select_months'
								"
								:span="5"
								:offset="1"
							>
								<div style="margin-bottom: 5px">Month</div>
								<div>
									<el-select
										class="select"
										v-model="months"
										filterable
										placeholder="Select Month"
										:multiple="true"
									>
										<el-option
											v-for="(item, key) in monthsItems"
											:key="key"
											:label="item.name"
											:value="item.value"
										>
										</el-option>
									</el-select>
								</div>
							</el-col>
						</el-row>
						<el-row v-if="frequency == 'daily'" style="margin-top: 30px">
							<el-col :span="3">
								<div>Time</div>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="daily_radio" label="anytime"
									>All Day
								</el-radio>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="daily_radio" label="specific_time"
									>Fixed Time
								</el-radio>
							</el-col>
						</el-row>
						<el-row v-if="frequency == 'weekly'" style="margin-top: 30px">
							<el-col :span="3">
								<div>Time</div>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="weekly_radio" label="anyday_in_the_week"
									>All Days
								</el-radio>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="weekly_radio" label="specific_day_in_a_week"
									>Fixed Days
								</el-radio>
							</el-col>
						</el-row>
						<el-row v-if="frequency == 'monthly'" style="margin-top: 30px">
							<el-col :span="3">
								<div>Days</div>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="monthly_radio" label="anytime_of_the_month"
									>All Days
								</el-radio>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="monthly_radio" label="date_of_the_month"
									>Fixed Days
								</el-radio>
							</el-col>
							<el-col :span="2" style="margin-left: 30px">
								<el-radio v-model="monthly_radio" label="for_a_date_range"
									>Due Date
								</el-radio>
							</el-col>
						</el-row>
						<el-row v-if="daily_radio == 'specific_time'">
							<el-col :span="14" :offset="3">
								<el-row
									class="project-table2"
									style="margin-top: 14px; border-radius: 12px"
								>
									<el-col :span="24">
										<el-table
											style="border-radius: 8px"
											:data="tableData_daily_radio"
										>
											<el-table-column width="100px" label="Sr No">
												<template slot-scope="scope">
													<div
														v-if="scope.row.srno_selection || scope.row.editing"
													>
														{{ tableData_daily_radio.length }}
													</div>
													<div v-else>{{ scope.row.srno }}</div>
												</template>
											</el-table-column>
											<el-table-column label="Start Time">
												<template slot-scope="scope">
													<div
														v-if="
															scope.row.start_time_selection ||
															scope.row.editing
														"
													>
														<el-time-select
															v-model="start_time"
															:picker-options="{
																start: '00:00',
																step: '00:30',
																end: '23:45',
															}"
															placeholder="Select time"
															class="date"
														>
														</el-time-select>
													</div>
													<div v-else>{{ scope.row.start_time }}</div>
												</template>
											</el-table-column>
											<el-table-column label="End Time">
												<template slot-scope="scope">
													<div
														v-if="
															scope.row.end_time_selection || scope.row.editing
														"
													>
														<el-time-select
															v-model="end_time"
															:picker-options="{
																start: '00:00',
																step: '00:30',
																end: '23:45',
															}"
															class="date"
															placeholder="Select time"
														>
														</el-time-select>
													</div>
													<div v-else>{{ scope.row.end_time }}</div>
												</template>
											</el-table-column>
											<el-table-column>
												<template slot-scope="scope">
													<el-button
														v-if="
															scope.row.start_time_selection ||
															scope.row.editing
														"
														icon="el-icon-plus"
														size="mini"
														class="button-class-white2"
														style="height: 30px"
														@click="add_more(2)"
														>Add</el-button
													>
													<el-button
														size="mini"
														style="border: none; background-color: transparent"
														@click="
															toggle_actions_edit(
																scope.$index,
																scope.row,
																'EDIT',
																2
															)
														"
														v-if="
															!scope.row.start_time_selection &&
															!scope.row.editing
														"
													>
														<img
															src="../../../assets/icons/edit_pencil_icon.png"
															width="10px"
															height="10px"
															alt=""
														/>
													</el-button>
													<el-button
														v-if="!scope.row.start_time_selection"
														icon="el-icon-delete"
														size="mini"
														style="border: none; background-color: transparent"
														@click="
															toggle_actions(
																scope.$index,
																scope.row,
																'DELETE',
																2
															)
														"
													></el-button>
												</template>
											</el-table-column>
										</el-table>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
						<el-row
							v-if="
								daily_radio == 'specific_time' &&
								!tableData_daily_radio[0].start_time_selection
							"
							style="margin-top: 20px"
						>
							<el-col :span="3" :offset="3">
								<el-button
									class="button-class-white2"
									style="margin-top: 0px"
									icon="el-icon-plus"
									@click="add_more(200)"
								>
									Add More
								</el-button>
							</el-col>
						</el-row>
						<el-row v-if="weekly_radio == 'specific_day_in_a_week'">
							<el-col :span="18" :offset="3">
								<el-row
									class="project-table2"
									style="margin-top: 14px; border-radius: 12px"
								>
									<el-col :span="24">
										<el-table
											style="border-radius: 8px"
											:data="tableData_weekly_radio"
										>
											<el-table-column width="100px" label="Sr No">
												<template slot-scope="scope">
													<div
														v-if="scope.row.srno_selection || scope.row.editing"
													>
														{{ tableData_weekly_radio.length }}
													</div>
													<div v-else>{{ scope.row.srno }}</div>
												</template>
											</el-table-column>
											<el-table-column label="Day">
												<template slot-scope="scope">
													<div
														v-if="scope.row.day_selection || scope.row.editing"
													>
														<el-select
															class="select"
															v-model="weekly_day"
															filterable
															placeholder="Select Day"
														>
															<el-option
																v-for="(item, key) in weekly_dayItems"
																:key="key"
																:label="item.name"
																:value="item.value"
															>
															</el-option>
														</el-select>
													</div>
													<div v-else>
														{{
															scope.row.day.charAt(0).toUpperCase() +
															scope.row.day.slice(1)
														}}
													</div>
												</template>
											</el-table-column>
											<el-table-column label="Frequency">
												<template slot-scope="scope">
													<div
														v-if="
															scope.row.frequency_selection || scope.row.editing
														"
													>
														<el-select
															class="select"
															v-model="weekly_frequency"
															filterable
															placeholder="Select Frequency"
														>
															<el-option
																v-for="(item, key) in weekly_frequencyItems"
																:key="key"
																:label="item.name"
																:value="item.value"
															>
															</el-option>
														</el-select>
													</div>
													<div v-else>
														{{
															scope.row.frequency == "anytime"
																? "Anytime"
																: "Fixed Time"
														}}
													</div>
												</template>
											</el-table-column>
											<el-table-column label="Start Time">
												<template slot-scope="scope">
													<div
														v-if="
															scope.row.start_time_selection ||
															scope.row.editing
														"
													>
														<el-time-select
															v-if="weekly_frequency == 'specific_time'"
															v-model="start_time"
															:picker-options="{
																start: '00:00',
																step: '00:30',
																end: '23:45',
															}"
															placeholder="Select time"
															class="date"
														>
														</el-time-select>
													</div>
													<div v-else>
														{{
															scope.row.start_time != ""
																? scope.row.start_time
																: "-"
														}}
													</div>
												</template>
											</el-table-column>
											<el-table-column label="End Time">
												<template slot-scope="scope">
													<div
														v-if="
															scope.row.end_time_selection || scope.row.editing
														"
													>
														<el-time-select
															v-if="weekly_frequency == 'specific_time'"
															v-model="end_time"
															:picker-options="{
																start: '00:00',
																step: '00:30',
																end: '23:45',
															}"
															placeholder="Select time"
															class="date"
														>
														</el-time-select>
													</div>
													<div v-else>
														{{
															scope.row.end_time != ""
																? scope.row.end_time
																: "-"
														}}
													</div>
												</template>
											</el-table-column>
											<el-table-column>
												<template slot-scope="scope">
													<el-button
														v-if="scope.row.day_selection || scope.row.editing"
														icon="el-icon-plus"
														size="mini"
														class="button-class-white2"
														style="height: 30px"
														@click="add_more(3)"
														>Add</el-button
													>
													<el-button
														size="mini"
														style="border: none; background-color: transparent"
														@click="
															toggle_actions_edit(
																scope.$index,
																scope.row,
																'EDIT',
																3
															)
														"
														v-if="
															!scope.row.day_selection && !scope.row.editing
														"
													>
														<img
															src="../../../assets/icons/edit_pencil_icon.png"
															width="10px"
															height="10px"
															alt=""
														/>
													</el-button>
													<el-button
														v-if="!scope.row.day_selection"
														icon="el-icon-delete"
														size="mini"
														style="border: none; background-color: transparent"
														@click="
															toggle_actions(
																scope.$index,
																scope.row,
																'DELETE',
																3
															)
														"
													></el-button>
												</template>
											</el-table-column>
										</el-table>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
						<el-row
							v-if="
								weekly_radio == 'specific_day_in_a_week' &&
								!tableData_weekly_radio[0].day_selection
							"
							style="margin-top: 20px"
						>
							<el-col :span="3" :offset="3">
								<el-button
									class="button-class-white2"
									style="margin-top: 0px"
									icon="el-icon-plus"
									@click="add_more(300)"
								>
									Add More
								</el-button>
							</el-col>
						</el-row>
						<el-row v-if="monthly_radio == 'date_of_the_month'">
							<el-col :span="16" :offset="3">
								<el-row
									class="project-table2"
									style="margin-top: 14px; border-radius: 12px"
								>
									<el-col :span="24">
										<el-table
											style="border-radius: 8px"
											:data="tableData_monthly_radio"
										>
											<el-table-column width="100px" label="Sr No">
												<template slot-scope="scope">
													<div
														v-if="scope.row.srno_selection || scope.row.editing"
													>
														{{ tableData_monthly_radio.length }}
													</div>
													<div v-else>{{ scope.row.srno }}</div>
												</template>
											</el-table-column>
											<el-table-column label="Day">
												<template slot-scope="scope">
													<div
														v-if="scope.row.day_selection || scope.row.editing"
													>
														<el-select
															class="select"
															v-model="monthly_day"
															filterable
															placeholder="Select Day"
														>
															<el-option
																v-for="(item, key) in monthly_dayItems"
																:key="key"
																:label="item.name"
																:value="item.value"
																:disabled="item.disabled"
															>
															</el-option>
															<el-option value="31st">
																<div
																	@click="disable_option(1)"
																	style="color: #d26300; font-weight: 600"
																>
																	Last day of the month
																</div>
															</el-option>
														</el-select>
													</div>
													<div v-else>
														{{ scope.row.day }}
													</div>
												</template>
											</el-table-column>
											<el-table-column label="Frequency">
												<template slot-scope="scope">
													<div
														v-if="
															scope.row.frequency_selection || scope.row.editing
														"
													>
														<el-select
															class="select"
															v-model="monthly_frequency"
															filterable
															placeholder="Select Frequency"
														>
															<el-option
																v-for="(item, key) in monthly_frequencyItems"
																:key="key"
																:label="item.name"
																:value="item.value"
															>
															</el-option>
														</el-select>
													</div>
													<div v-else>
														{{
															scope.row.frequency == "anytime"
																? "Anytime"
																: "Fixed Time"
														}}
													</div>
												</template>
											</el-table-column>
											<el-table-column label="Start Time">
												<template slot-scope="scope">
													<div
														v-if="
															scope.row.start_time_selection ||
															scope.row.editing
														"
													>
														<el-time-select
															v-if="monthly_frequency == 'specific_time'"
															v-model="start_time"
															:picker-options="{
																start: '00:00',
																step: '00:30',
																end: '23:45',
															}"
															placeholder="Select time"
															class="date"
														>
														</el-time-select>
													</div>
													<div v-else>
														{{
															scope.row.start_time != ""
																? scope.row.start_time
																: "-"
														}}
													</div>
												</template>
											</el-table-column>
											<el-table-column label="End Time">
												<template slot-scope="scope">
													<div
														v-if="
															scope.row.end_time_selection || scope.row.editing
														"
													>
														<el-time-select
															v-if="monthly_frequency == 'specific_time'"
															v-model="end_time"
															:picker-options="{
																start: '00:00',
																step: '00:30',
																end: '23:45',
															}"
															placeholder="Select time"
															class="date"
														>
														</el-time-select>
													</div>
													<div v-else>
														{{
															scope.row.end_time != ""
																? scope.row.end_time
																: "-"
														}}
													</div>
												</template>
											</el-table-column>
											<el-table-column>
												<template slot-scope="scope">
													<el-button
														v-if="scope.row.day_selection"
														icon="el-icon-plus"
														size="mini"
														class="button-class-white2"
														style="height: 30px"
														@click="add_more(4)"
														>Add</el-button
													>
													<el-button
														size="mini"
														style="border: none; background-color: transparent"
														@click="
															toggle_actions_edit(
																scope.$index,
																scope.row,
																'EDIT',
																4
															)
														"
														v-if="
															!scope.row.day_selection && !scope.row.editing
														"
													>
														<img
															src="../../../assets/icons/edit_pencil_icon.png"
															width="10px"
															height="10px"
															alt=""
														/>
													</el-button>
													<el-button
														v-if="!scope.row.day_selection"
														icon="el-icon-delete"
														size="mini"
														style="border: none; background-color: transparent"
														@click="
															toggle_actions(
																scope.$index,
																scope.row,
																'DELETE',
																4
															)
														"
													></el-button>
												</template>
											</el-table-column>
										</el-table>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
						<el-row
							v-if="
								monthly_radio == 'date_of_the_month' &&
								!tableData_monthly_radio[0].day_selection
							"
							style="margin-top: 20px"
						>
							<el-col :span="3" :offset="3">
								<el-button
									class="button-class-white2"
									style="margin-top: 0px"
									icon="el-icon-plus"
									@click="add_more(400)"
								>
									Add More
								</el-button>
							</el-col>
						</el-row>
						<el-row
							style="margin-top: 10px"
							v-if="monthly_radio == 'for_a_date_range'"
						>
							<el-col :span="3" :offset="3">
								<div style="margin-bottom: 5px">Start Day</div>
								<el-select
									class="select"
									v-model="monthly_start_day"
									filterable
									placeholder="Select Start Day"
								>
									<el-option
										v-for="(item, key) in monthly_dayItems"
										:key="key"
										:label="item.name"
										:value="item.value"
										:disabled="item.disabled"
									>
									</el-option>
									<el-option value="">
										<div
											@click="disable_option()"
											style="color: #d26300; font-weight: 600"
										>
											Last day of the month
										</div>
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="3" :offset="1">
								<div style="margin-bottom: 5px">End Day</div>
								<el-select
									class="select"
									v-model="monthly_end_day"
									filterable
									placeholder="Select End Day"
								>
									<el-option
										v-for="(item, key) in monthly_dayItems"
										:key="key"
										:label="item.name"
										:value="item.value"
										:disabled="item.disabled"
									>
									</el-option>
									<div
										@click="disable_option()"
										style="
											color: #d26300;
											font-weight: 600;
											position: sticky;
											bottom: 0;
											padding: 2px 5px;
											background: white;
										"
									>
										Last day of the month
									</div>
								</el-select>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px">
							<el-col :span="3">
								<div>Assign By</div>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="assign_radio" label="1">Location </el-radio>
							</el-col>
							<el-col :span="4">
								<el-radio v-model="assign_radio" label="2"
									>Location Type / Business Model
								</el-radio>
							</el-col>
						</el-row>
						<el-row v-if="assign_radio == '1'" style="margin-top: 30px">
							<el-col style="margin-top: -25px" :span="3">
								<div>Location</div>
							</el-col>
							<el-col :span="8">
								<el-select
									class="select"
									v-model="locations"
									filterable
									placeholder="Select Locations"
									:multiple="true"
									v-validate="'required'"
									name="Select Locations"
									style="text-transform: capitalize"
									:collapse-tags="true"
								>
									<!-- <el-option> -->
									<el-row style="height: 30px" :gutter="5">
										<el-col :span="12"
											><div
												@click="select_all('location')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Select All
											</div></el-col
										>
										<el-col :span="12"
											><div
												@click="clear_all('location')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Clear All
											</div></el-col
										>
									</el-row>
									<!-- </el-option> -->
									<el-option
										v-for="(item, key) in locationItems"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="errors.has(`Select Locations`)"
										class="text-red-dark text-xs"
									>
										{{
											errors.first(`Select Locations`)
												? "This field is required"
												: ""
										}}
									</span>
								</p>
								<div style="margin-top: 10px">
									<el-popover
										placement="right-start"
										title="Location List"
										width="300"
										trigger="hover"
									>
										<div
											slot="reference"
											style="word-break: break-word; line-height: 120%"
											v-text="`Location Selected - ${locations.length}`"
										></div>
										<div
											v-for="(item, idx) in locations.map((elem) =>
												locationItems.find((el) => elem === el.id)
											)"
											:key="idx"
										>
											{{ item ? (item.name ? item.name : "") : "" }} <br />
										</div>
									</el-popover>
								</div>
							</el-col>
						</el-row>
						<el-row v-if="assign_radio == '2'" style="margin-top: 30px">
							<el-col style="margin-top: -25px" :span="3">
								<div>
									Location Type /
									<div>Business Model</div>
								</div>
							</el-col>
							<el-col :span="7">
								<el-select
									class="select"
									v-model="location_business"
									filterable
									placeholder="Select Location Type / Business Model"
									v-validate="'required'"
									name="Select Location Type / Business Model"
									style="text-transform: capitalize"
								>
									<el-option
										v-for="item in location_businessItems"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="
											errors.has(`Select Location Type / Business Model`)
										"
										class="text-red-dark text-xs"
									>
										{{
											errors.first(`Select Location Type / Business Model`)
												? "This field is required"
												: ""
										}}
									</span>
								</p>
								<div style="margin-top: 10px">
									Location Type / Business Model Selected -
									{{ location_business }}
								</div>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px">
							<el-col style="margin-top: -25px" :span="3">
								<div>Assign To</div>
							</el-col>
							<el-col :span="8">
								<el-select
									class="select"
									v-model="designation"
									filterable
									placeholder="Select Designation"
									:multiple="true"
									v-validate="'required'"
									name="Select Designation"
									:collapse-tags="true"
								>
									<el-row style="height: 30px" :gutter="5">
										<el-col :span="12"
											><div
												@click="select_all('designation')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Select All
											</div></el-col
										>
										<el-col :span="12"
											><div
												@click="clear_all('designation')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Clear All
											</div></el-col
										>
									</el-row>
									<el-option
										v-for="(item, key) in designationItems"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<p>
									<span
										:v-show="errors.has(`Select Designation`)"
										class="text-red-dark text-xs"
									>
										{{
											errors.first(`Select Designation`)
												? "This field is required"
												: ""
										}}
									</span>
								</p>
								<div style="margin-top: 10px">
									<el-popover
										placement="right-start"
										title="Designation List"
										width="300"
										trigger="hover"
									>
										<div
											slot="reference"
											style="word-break: break-word; line-height: 120%"
											v-text="`Designation Selected - ${designation.length}`"
										></div>
										<div
											v-for="(item, idx) in designation.map((elem) =>
												designationItems.find((el) => elem === el.id)
											)"
											:key="idx"
										>
											{{ item ? (item.name ? item.name : "") : "" }} <br />
										</div>
									</el-popover>
								</div>
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px">
							<el-col :span="3">
								<div>Project Sign Off</div>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="project_sign_off" label="yes">Yes </el-radio>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="project_sign_off" label="no">No </el-radio>
							</el-col>
						</el-row>
						<el-row v-if="project_sign_off == 'yes'" style="margin-top: 30px">
							<el-col :span="3">
								<div class="mr-4">Auditor Signature Required</div>
							</el-col>
							<el-col :span="2">
								<el-checkbox
									v-model="signature_required"
									:label="signature_required ? 'yes' : 'no'"
								/>
							</el-col>
						</el-row>
						<el-row v-if="signature_required" style="margin-top: 30px">
							<el-col :span="3">
								<div>Auditee</div>
							</el-col>
							<el-col :span="6">
								<el-select
									class="select"
									v-model="auditee_designation"
									filterable
									placeholder="Select Auditee"
									:multiple="true"
									name="Select Auditee"
									:collapse-tags="true"
									@change="reports_designation_setting()"
								>
									<el-row style="height: 30px" :gutter="5">
										<el-col :span="12"
											><div
												@click="select_all('auditee')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Select All
											</div></el-col
										>
										<el-col :span="12"
											><div
												@click="clear_all('auditee')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Clear All
											</div></el-col
										>
									</el-row>
									<el-option
										v-for="(item, key) in designationItems"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<div style="margin-top: 10px">
									<el-popover
										placement="right-start"
										title="Reports List"
										width="300"
										trigger="hover"
									>
										<div
											slot="reference"
											style="word-break: break-word; line-height: 120%"
											v-text="
												`Auditee Selected - ${auditee_designation.length}`
											"
										></div>
										<div
											v-for="(item, idx) in auditee_designation.map((elem) =>
												designationItems.find((el) => elem === el.id)
											)"
											:key="idx"
										>
											{{ item ? (item.name ? item.name : "") : "" }} <br />
										</div>
									</el-popover>
								</div>
							</el-col>
						</el-row>
					</div>
					<el-row>
						<el-col
							style="margin-top: 40px; margin-right: 20px"
							v-if="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
							"
							:span="2"
							:offset="17"
						>
							<el-button
								@click="go_back()"
								class="button-class-white2"
								style="border: none"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col
							style="margin-top: 40px; margin-right: 0px"
							:span="2"
							:offset="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
									? 0
									: 17
							"
						>
							<el-button @click="prevStep(1)" class="button-class-white2">
								Back
							</el-button>
						</el-col>
						<el-col :span="3">
							<el-button @click="nextStep(2)" class="button-class">
								Continue
							</el-button>
						</el-col>
					</el-row>
				</div>
				<div v-if="createProjectItems[2].active">
					<div
						style="
							min-height: 65vh;
							max-height: 65vh;
							overflow-y: auto;
							overflow-x: hidden;
						"
					>
						<el-row style="margin-top: 30px">
							<el-col :span="3">
								<div>Grades</div>
							</el-col>
							<el-col :span="2">
								<el-radio v-model="grades_radio" label="1"
									>Applicable
								</el-radio>
							</el-col>
							<el-col :span="2" :offset="1">
								<el-radio v-model="grades_radio" label="2"
									>Not Applicable
								</el-radio>
							</el-col>
						</el-row>
						<el-row v-if="grades_radio == '1'" style="margin-top: 30px">
							<el-col :span="3">
								<div>Project Title</div>
							</el-col>
							<el-col :span="20">{{ project_title }} </el-col>
						</el-row>
						<el-row v-if="grades_radio == '1'" style="margin-top: 30px">
							<el-col :span="3">
								<div>Total Points</div>
							</el-col>
							<el-col :span="20">{{ totalPoints }} </el-col>
						</el-row>
						<el-row v-if="grades_radio == '1'">
							<el-col style="margin-top: 0px" :span="3">
								<div>Range</div>
							</el-col>
							<el-col :span="20" :offset="0">
								<el-row
									class="project-table2"
									style="margin-top: 14px; border-radius: 12px"
								>
									<el-col :span="24">
										<el-table
											style="border-radius: 8px"
											:data="tableData_range"
										>
											<el-table-column width="100px" label="Sr No">
												<template slot-scope="scope">
													<div v-if="scope.row.srno_selection">
														{{ tableData_range.length }}
													</div>
													<div v-else-if="scope.row.editing">
														{{ scope.row.srno }}
													</div>
													<div v-else>{{ scope.row.srno }}</div>
												</template>
											</el-table-column>
											<el-table-column
												min-width="100px"
												max-width="100px"
												label="From"
											>
												<!-- scope.row.from_score_selection || -->

												<template slot-scope="scope">
													<el-row
														v-if="scope.row.editing || scope.row.srno_selection"
													>
														<el-col :span="14">
															<!-- <el-select
																class="select"
																v-model="from_score"
																filterable
																placeholder="From"
															>
																<el-option
																	v-for="(item, idx) in from_scoreItems"
																	:key="idx"
																	:label="item.name"
																	:value="item.value"
																>
																</el-option>
															</el-select> -->
															<el-input
																type="text"
																v-model="from_score"
																placeholder="Enter From Score"
																class="input-class"
																v-validate="'required'"
																name="Enter From Score"
																:minlength="1"
																:maxlength="6"
															/>
														</el-col>
														<!-- <el-col :span="7" :offset="1">
															<el-select
																class="select"
																v-model="from_score_decimal"
																filterable
																placeholder="Select "
															>
																<el-option
																	v-for="(item, idx) in from_scoreItems_decimal"
																	:key="idx"
																	:label="item.name"
																	:value="item.value"
																>
																</el-option>
															</el-select>
														</el-col> -->
													</el-row>
													<div v-else>
														{{ scope.row.from_score }}
														<!-- .{{
															scope.row.from_score_decimal
																? scope.row.from_score_decimal.split(".")[1]
																: "00"
														}}% -->
													</div>
												</template>
											</el-table-column>
											<el-table-column
												min-width="100px"
												max-width="100px"
												label="To"
											>
												<template slot-scope="scope">
													<el-row
														v-if="scope.row.editing || scope.row.srno_selection"
													>
														<el-col :span="14" :offset="2">
															<el-input
																type="text"
																v-model="to_score"
																placeholder="Enter To Score"
																class="input-class"
																v-validate="'required'"
																name="Enter To Score"
																:minlength="1"
																:maxlength="6"
															/>
														</el-col>
													</el-row>
													<div v-else>
														{{ scope.row.to_score }}
													</div>
												</template>
											</el-table-column>
											<el-table-column prop="grade" label="Grade">
												<template slot-scope="scope">
													<div
														v-if="scope.row.editing || scope.row.srno_selection"
													>
														<el-select
															class="select"
															v-model="grade"
															filterable
															placeholder="Select Grade"
														>
															<el-option
																v-for="(item, idx) in gradeItems"
																:key="idx"
																:label="item.label"
																:value="item.value"
																:disabled="item.disabled"
															>
															</el-option>
														</el-select>
													</div>
													<div v-else>
														{{ scope.row.grade }}
													</div>
												</template>
											</el-table-column>
											<el-table-column>
												<template slot-scope="scope">
													<el-button
														v-if="scope.row.editing || scope.row.srno_selection"
														icon="el-icon-plus"
														size="mini"
														class="button-class-white2"
														style="height: 30px"
														@click="add_more(5, scope.$index, scope.row)"
														>Add</el-button
													>
													<el-button
														v-if="scope.row.editing || scope.row.srno_selection"
														icon="el-icon-close"
														size="mini"
														class="button-class-white2"
														style="height: 30px"
														@click="
															toggle_actions_cancel_button(
																5,
																scope.$index,
																scope.row
															)
														"
														>Cancel</el-button
													>
													<el-button
														size="mini"
														style="border: none; background-color: transparent"
														@click="
															toggle_actions_edit(
																scope.$index,
																scope.row,
																'EDIT',
																5
															)
														"
														v-if="
															!scope.row.srno_selection && !scope.row.editing
														"
													>
														<img
															src="../../../assets/icons/edit_pencil_icon.png"
															width="10px"
															height="10px"
															alt=""
														/>
													</el-button>
													<el-button
														icon="el-icon-delete"
														size="mini"
														style="border: none; background-color: transparent"
														@click="
															toggle_actions(
																scope.$index,
																scope.row,
																'DELETE',
																5
															)
														"
													></el-button>
												</template>
											</el-table-column>
										</el-table>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
						<!-- && !tableData_range[0].from_score_selection -->
						<el-row v-if="grades_radio == '1'" style="margin-top: 30px">
							<el-col :span="3" :offset="3">
								<el-button
									class="button-class-white2"
									style="margin-top: 0px"
									icon="el-icon-plus"
									@click="add_more(500)"
								>
									Add More
								</el-button>
							</el-col>
						</el-row>
					</div>
					<el-row>
						<el-col
							style="margin-top: 40px; margin-right: 20px"
							v-if="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
							"
							:span="2"
							:offset="17"
						>
							<el-button
								@click="go_back()"
								class="button-class-white2"
								style="border: none"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col
							style="margin-top: 40px; margin-right: 0px"
							:span="2"
							:offset="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
									? 0
									: 17
							"
						>
							<el-button @click="prevStep(2)" class="button-class-white2">
								Back
							</el-button>
						</el-col>
						<el-col :span="3">
							<el-button @click="nextStep(3)" class="button-class">
								Continue
							</el-button>
						</el-col>
					</el-row>
				</div>
				<div v-if="createProjectItems[3].active">
					<div style="margin-top: 30px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 15%">
							<strong>Actions</strong>
						</div>
						<div style="flex: 0 0 40%; display: flex">
							<el-radio v-model="selectedAction" label="applicable"
								>Applicable</el-radio
							>
							<el-radio v-model="selectedAction" label="not_applicable"
								>Not applicable</el-radio
							>
						</div>
					</div>
					<div style="margin-top: 10px; display: flex">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 70%">
							<p>
								Note - Any non-compliant questions will become a part of
								corrective action plan. Location managers will be required to
								submit an action plan on completion of each project
							</p>
						</div>
						<div style="flex: 0 0 25%"></div>
					</div>
					<div style="margin-top: 40px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 15%">
							<strong>Raise Action</strong>
						</div>
						<div style="flex: 0 0 40%; display: flex">
							<el-radio v-model="raiseAction" label="applicable"
								>Applicable</el-radio
							>
							<el-radio v-model="raiseAction" label="not_applicable"
								>Not applicable</el-radio
							>
						</div>
					</div>
					<div style="margin-top: 10px; display: flex">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 65%">
							<p>
								Note - An assignee can create and assign actions manually for
								any steps throughout the project
							</p>
						</div>
						<div style="flex: 0 0 15%"></div>
					</div>
					<div style="margin-top: 40px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 15%">
							<strong>Open Actions</strong>
						</div>

						<div style="flex: 0 0 40%; display: flex">
							<el-radio v-model="openActions" label="project_can_be_completed"
								>Project can be completed</el-radio
							>
							<el-radio v-model="openActions" label="project_on_hold"
								>Project on hold</el-radio
							>
						</div>
					</div>
					<div style="margin-top: 10px; display: flex">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 65%">
							<p>
								Note - Status of the Projects can be kept on hold if Action plan
								is not submitted
							</p>
						</div>
					</div>
					<div style="flex: 0 0 15%"></div>

					<div style="margin-top: 40px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 15%">
							<strong>Upload Files</strong>
						</div>
						<div style="flex: 0 0 40%; display: flex">
							<el-radio v-model="uploadFiles" label="mandatory"
								>Mandatory</el-radio
							>
							<el-radio v-model="uploadFiles" label="optional"
								>Optional</el-radio
							>
						</div>
					</div>
					<div style="margin-top: 10px; display: flex">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 65%">
							<p>
								Note - Upload a supporting file can be made mandatory for every
								Action
							</p>
						</div>
						<div style="flex: 0 0 15%"></div>
					</div>
					<div style="margin-top: 40px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<strong style="flex: 0 0 15%">To Be Completed By</strong>
						<div style="flex: 0 0 15%">
							<el-select
								class="select"
								v-model="to_be_completed_by"
								filterable
								placeholder="Select Designation"
								:multiple="true"
								name="Select Completed Designation"
								:collapse-tags="true"
							>
								<el-row style="height: 30px" :gutter="5">
									<el-col :span="12"
										><div
											@click="select_all('to_be_completed_by')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Select All
										</div></el-col
									>
									<el-col :span="12"
										><div
											@click="clear_all('to_be_completed_by')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Clear All
										</div></el-col
									>
								</el-row>
								<el-option
									v-for="(item, key) in designationItemsNA"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Completed Designation`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Completed Designation`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</div>
					</div>
					<div style="margin-top: 40px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<strong style="flex: 0 0 15%">Submit Action Plan Within</strong>
						<div style="flex: 0 0 15%">
							<el-select
								class="select"
								v-model="days_for_due_date"
								filterable
								placeholder="Select days"
								name="Select days"
								v-validate="'required'"
								@change="update_due_date"
							>
								<el-option
									v-for="(item, key) in days_for_due_dateItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select days`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select days`) ? "This field is required" : ""
									}}
								</span>
							</p>
						</div>
					</div>
					<div style="margin-top: 40px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 15%">
							<strong>Approval Required</strong>
						</div>
						<div style="flex: 0 0 40%; display: flex">
							<el-radio v-model="approvalRequired" label="Yes">Yes</el-radio>
							<el-radio v-model="approvalRequired" label="No"
								>Not Required</el-radio
							>
						</div>
					</div>
					<div style="margin-top: 40px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<strong style="flex: 0 0 15%">Approval By</strong>
						<div style="flex: 0 0 15%">
							<el-select
								class="select"
								v-model="approval_by"
								filterable
								placeholder="Select Designation"
								:multiple="true"
								name="Select Approval Designation"
								:collapse-tags="true"
							>
								<el-row style="height: 30px" :gutter="5">
									<el-col :span="12"
										><div
											@click="select_all('approval_by')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Select All
										</div></el-col
									>
									<el-col :span="12"
										><div
											@click="clear_all('approval_by')"
											style="
												cursor: pointer;
												color: #d26300;
												text-align: center;
											"
										>
											Clear All
										</div></el-col
									>
								</el-row>
								<el-option
									v-for="(item, key) in designationItemsNA"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Approval Designation`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Approval Designation`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</div>
					</div>
					<div style="margin-top: 40px; display: flex; align-items: center">
						<div style="flex: 0 0 10%"></div>
						<strong style="flex: 0 0 15%">Auto-Approve</strong>
						<div style="flex: 0 0 15%">
							<el-select
								class="select"
								v-model="autoApproveDays"
								filterable
								placeholder="Select days"
								name="Select Auto days"
								v-validate="'required'"
								@change="update_due_date"
							>
								<el-option
									v-for="(item, key) in days_for_due_dateItems"
									:key="key"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
							<p>
								<span
									:v-show="errors.has(`Select Auto days`)"
									class="text-red-dark text-xs"
								>
									{{
										errors.first(`Select Auto days`)
											? "This field is required"
											: ""
									}}
								</span>
							</p>
						</div>
					</div>
					<div style="margin-top: 10px; display: flex">
						<div style="flex: 0 0 10%"></div>
						<div style="flex: 0 0 65%">
							<p>
								Note - Action plans will be automatically approved if not
								manually reviewed and approved within the specified timeframe
							</p>
						</div>
						<div style="flex: 0 0 15%"></div>
					</div>
					<el-row style="margin-top: 4vh">
						<el-col
							style="margin-top: 40px; margin-right: 20px"
							v-if="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
							"
							:span="2"
							:offset="17"
						>
							<el-button
								@click="go_back()"
								class="button-class-white2"
								style="border: none"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col
							style="margin-top: 40px; margin-right: 0px"
							:span="2"
							:offset="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
									? 0
									: 17
							"
						>
							<el-button @click="prevStep(3)" class="button-class-white2">
								Back
							</el-button>
						</el-col>
						<el-col :span="3">
							<el-button @click="nextStep(4)" class="button-class">
								Continue
							</el-button>
						</el-col>
					</el-row>
				</div>
				<div v-if="createProjectItems[4].active">
					<div
						style="
							min-height: 65vh;
							max-height: 65vh;
							overflow-y: auto;
							overflow-x: hidden;
						"
					>
						<el-row style="margin-top: 30px">
							<el-col style="margin-top: 0px" :span="3">
								<div>Reports</div>
							</el-col>
							<el-col :span="6">
								<el-select
									class="select"
									v-model="reports_designation"
									filterable
									placeholder="Select Designation"
									:multiple="true"
									name="Select Designation"
									:collapse-tags="true"
								>
									<el-row style="height: 30px" :gutter="5">
										<el-col :span="12"
											><div
												@click="select_all('reports')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Select All
											</div></el-col
										>
										<el-col :span="12"
											><div
												@click="clear_all('reports')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Clear All
											</div></el-col
										>
									</el-row>
									<el-option
										v-for="(item, key) in designationItemsNA"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<div
									v-if="reports_designation != 'Not Applicable'"
									style="margin-top: 10px"
								>
									<el-popover
										placement="right-start"
										title="Reports List"
										width="300"
										trigger="hover"
									>
										<div
											slot="reference"
											style="word-break: break-word; line-height: 120%"
											v-text="
												`Designation Selected - ${reports_designation.length}`
											"
										></div>
										<div
											v-for="(item, idx) in reports_designation.map((elem) =>
												designationItemsNA.find((el) => elem === el.id)
											)"
											:key="idx"
										>
											{{ item ? (item.name ? item.name : "") : "" }} <br />
										</div>
									</el-popover>
								</div>
							</el-col>
						</el-row>

						<el-row style="margin-top: 20px">
							<el-col :span="10" :offset="3">
								Users with selected Designation can view and receive Project
								Reports
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px">
							<el-col :span="3">
								<div style="margin-top: 0px">Notifications</div>
							</el-col>
							<el-col :span="6">
								<el-select
									class="select"
									v-model="notification_designation"
									@change="notification_designation_setting()"
									filterable
									placeholder="Select Designation"
									:multiple="true"
									name="Select Designation"
									:collapse-tags="true"
								>
									<el-row style="height: 30px" :gutter="5">
										<el-col :span="12"
											><div
												@click="select_all('notification')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Select All
											</div></el-col
										>
										<el-col :span="12"
											><div
												@click="clear_all('notification')"
												style="
													cursor: pointer;
													color: #d26300;
													text-align: center;
												"
											>
												Clear All
											</div></el-col
										>
									</el-row>
									<el-option
										v-for="(item, key) in designationItemsNA"
										:key="key"
										:label="item.name"
										:value="item.id"
									>
									</el-option>
								</el-select>
								<div
									v-if="notification_designation != 'Not Applicable'"
									style="margin-top: 10px"
								>
									<el-popover
										placement="right-start"
										title="Notification List"
										width="300"
										trigger="hover"
									>
										<div
											slot="reference"
											style="word-break: break-word; line-height: 120%"
											v-text="
												`Designation Selected - ${notification_designation.length}`
											"
										></div>
										<div
											v-for="(item, idx) in notification_designation.map(
												(elem) =>
													designationItemsNA.find((el) => elem === el.id)
											)"
											:key="idx"
										>
											{{ item ? (item.name ? item.name : "") : "" }} <br />
										</div>
									</el-popover>
								</div>
							</el-col>
						</el-row>
						<el-row style="margin-top: 20px">
							<el-col :span="10" :offset="3">
								Users with selected Designation will get project notifications
								on mobile app
							</el-col>
						</el-row>

						<el-row style="margin-top: 30px">
							<el-col :span="4">
								<div>Trigger Notification</div>
							</el-col>
							<el-col :span="4">
								<el-switch
									active-color="#41BE62"
									active-text="Project Start"
									v-model="project_start"
								/>
							</el-col>
							<el-col :span="4">
								<el-switch
									active-color="#41BE62"
									active-text="Project Completed"
									v-model="project_completed"
								/>
							</el-col>
							<el-col :span="3">
								<el-switch
									active-color="#41BE62"
									active-text="Project Overdue"
									v-model="project_overdue"
								/>
							</el-col>
						</el-row>
						<el-row style="margin-top: 20px">
							<el-col :span="15" :offset="3">
								Users with selected Designation will receive an email and app
								notification when a project is Active, Completed or Overdue
							</el-col>
						</el-row>
						<el-row style="margin-top: 30px">
							<el-col :span="3">
								<div style="margin-top: 0px">Reminder</div>
							</el-col>
							<el-col style="margin-top: -2px" :span="2">
								<el-tooltip
									class="item"
									effect="dark"
									:content="
										before_start_category == 'minutes'
											? 'Must be between 0 and 40,320 minutes'
											: before_start_category == 'hours'
											? 'Must be between 0 and 642 hours'
											: 'Must be between 0 and 28 days'
									"
									placement="bottom"
								>
									<el-input
										placeholder="Select"
										v-model="before_start"
										class="input-class mt-0"
										type="number"
										name="Select"
									/>
								</el-tooltip>
							</el-col>
							<el-col :span="3" style="margin-left: 20px">
								<el-select
									class="select"
									v-model="before_start_category"
									filterable
									placeholder="Select"
									name="Select"
								>
									<el-option
										v-for="(item, idx) in before_start_categoryItems"
										:key="idx"
										:label="item.label"
										:value="item.value"
									>
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="3" style="margin-left: 20px; margin-top: 0px">
								before Project Starts
							</el-col>
							<el-col style="margin-top: -2px" :span="2" :offset="1">
								<el-tooltip
									class="item"
									effect="dark"
									:content="
										before_ends_category == 'minutes'
											? 'Must be between 0 and 40,320 minutes'
											: before_ends_category == 'hours'
											? 'Must be between 0 and 642 hours'
											: 'Must be between 0 and 28 days'
									"
									placement="bottom"
								>
									<el-input
										placeholder="Select"
										v-model="before_ends"
										class="input-class"
										type="number"
										name="Select"
									/>
								</el-tooltip>
							</el-col>
							<el-col :span="3" style="margin-left: 20px">
								<el-select
									class="select"
									v-model="before_ends_category"
									filterable
									placeholder="Select"
									name="Select"
								>
									<el-option
										v-for="(item, idx) in before_start_categoryItems"
										:key="idx"
										:label="item.label"
										:value="item.value"
									>
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="3" style="margin-left: 20px; margin-top: 0px">
								before Project ends
							</el-col>
						</el-row>
					</div>
					<el-row>
						<el-col
							style="margin-top: 40px; margin-right: 20px"
							v-if="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
							"
							:span="2"
							:offset="17"
						>
							<el-button
								@click="go_back()"
								class="button-class-white2"
								style="border: none"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col
							style="margin-top: 40px; margin-right: 0px"
							:span="2"
							:offset="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
									? 0
									: 17
							"
						>
							<el-button @click="prevStep(4)" class="button-class-white2">
								Back
							</el-button>
						</el-col>
						<el-col :span="3">
							<el-button @click="nextStep(5)" class="button-class">
								Continue
							</el-button>
						</el-col>
					</el-row>
				</div>
				<div v-if="createProjectItems[5].active">
					<el-row :gutter="5">
						<el-col :span="20" style="margin-left: 20px">
							<h2>Review</h2>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px; margin-left: 25px">
						<el-col :span="4" :offset="0"> Project Title </el-col>
						<el-col :span="4">
							<b>{{ project_title }}</b></el-col
						>
					</el-row>
					<el-row
						class="project-table01"
						style="
							margin-top: 14px;
							border-radius: 0px;
							border-bottom: 0px solid;
							border-left: 1px solid;
							border-right: 1px solid;
							border-top: 1px solid;
							border-color: #e2e5ea;
						"
					>
						<el-col :span="24">
							<el-table style="border-radius: 8px" :data="tableData">
								<el-table-column width="100px" prop="srno" label="Sr No">
								</el-table-column>
								<el-table-column width="400px" prop="category" label="Category">
								</el-table-column>
								<el-table-column prop="form_length" label="Forms">
								</el-table-column>
								<el-table-column prop="points" label="Points">
								</el-table-column>
								<el-table-column label="Critical">
									<template slot-scope="scope">
										{{ scope.row.critical ? "Yes" : "No" }}
									</template>
								</el-table-column>
								<el-table-column prop="allowedon" label="Allowed On">
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<el-row
						v-if="tableData.length > 0"
						class="project-table00"
						style="
							border-radius: 0px;
							border-left: 1px solid;
							border-right: 1px solid;
							border-top: 0px solid;
							border-color: #e2e5ea;
						"
					>
						<el-col :span="24">
							<el-table
								empty-text=""
								style="border-radius: 8px"
								:data="tableData1"
							>
								<el-table-column width="100px"> </el-table-column>
								<el-table-column width="400px" label="Total"> </el-table-column>
								<el-table-column :label="getTotal"> </el-table-column>
								<el-table-column :label="getPoints"> </el-table-column>
								<el-table-column> </el-table-column>
								<el-table-column> </el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Validity </el-col>
						<el-col :span="10">
							{{ moment(start_date).format("Do MMM YYYY") }} -
							{{
								never == true
									? "All Time"
									: moment(end_date).format("Do MMM YYYY")
							}}</el-col
						>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Frequency </el-col>
						<el-col :span="10">
							<div>{{ frequency }}</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Time </el-col>
						<el-col :span="4">All Time</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Location </el-col>
						<el-col :span="12">
							<!-- {{ locations.length }} Locations -->
							<span v-for="(item, idx) in locationItems" :key="idx">
								<span
									v-for="(item1, idx1) in locations.slice(0, 5)"
									:key="idx1"
								>
									<span v-if="item.id == item1 ? item.name : null">
										<el-tag
											class="mr-3"
											size="small"
											style="
												border-radius: 12px;
												text-align: center;
												border-color: #f9a168;
												background-color: #fff9f4;
												color: black;
												margin-bottom: 10px;
											"
											>{{ item.name }}
										</el-tag>
									</span>
								</span>
							</span>
						</el-col>
						<el-popover
							placement="right-start"
							title="Location List"
							width="300"
							trigger="hover"
						>
							<div
								slot="reference"
								style="word-break: break-word; line-height: 120%"
								v-text="`+${locations.length - 5} Others`"
							></div>
							<div
								v-for="(item, idx) in locations.map((elem) =>
									locationItems.find((el) => elem === el.id)
								)"
								:key="idx"
							>
								{{ item ? (item.name ? item.name : "") : "" }} <br />
							</div>
						</el-popover>
					</el-row>
					<el-row style="margin-top: 10px">
						<el-col :span="4" :offset="1"> </el-col>
						<el-col :span="18">
							<div><b>Total - </b> {{ locations.length }} Locations</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Assigned To </el-col>
						<el-col :span="12">
							<!-- {{ designation.length }} Designations -->
							<span v-for="(item, idx) in designationItems" :key="idx">
								<span
									v-for="(item1, idx1) in designation.slice(0, 5)"
									:key="idx1"
								>
									<span v-if="item.id == item1 ? item.name : null">
										<el-tag
											class="mr-3"
											size="small"
											style="
												border-radius: 12px;
												text-align: center;
												border-color: #f9a168;
												background-color: #fff9f4;
												color: black;
												margin-bottom: 10px;
											"
											>{{ item.name }}
										</el-tag>
									</span>
								</span>
							</span>
						</el-col>
						<el-popover
							placement="right-start"
							title="Designation List"
							width="300"
							trigger="hover"
						>
							<div
								slot="reference"
								style="word-break: break-word; line-height: 120%"
								v-text="`+${designation.length - 5} Others`"
							></div>
							<div
								v-for="(item, idx) in designation.map((elem) =>
									designationItems.find((el) => elem === el.id)
								)"
								:key="idx"
							>
								{{ item ? (item.name ? item.name : "") : "" }} <br />
							</div>
						</el-popover>
					</el-row>

					<el-row style="margin-top: 10px">
						<el-col :span="4" :offset="1"> </el-col>
						<el-col :span="18">
							<div><b>Total - </b> {{ designation.length }} Designations</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Grades </el-col>
						<el-col :span="10">
							<el-row v-if="tableData_range.length != 0">
								<el-col :span="15">
									<el-row
										class="project-table9"
										style="
											margin-top: 14px;
											border-radius: 0px;
											border-bottom: 0px solid;
											border-left: 1px solid;
											border-right: 1px solid;
											border-top: 1px solid;
											border-color: #e2e5ea;
										"
									>
										<el-col :span="24">
											<el-table
												style="border-radius: 8px"
												:data="tableData_range"
											>
												<el-table-column prop="srno" label="Sr No">
												</el-table-column>
												<el-table-column label="Range">
													<template slot-scope="scope">
														<div>
															{{ scope.row.from_score }} -
															{{ scope.row.to_score }}
														</div>
													</template>
												</el-table-column>
												<el-table-column label="Score %">
													<template slot-scope="scope">
														<div>
															{{ scope.row.from_score / 10 }} -
															{{ scope.row.to_score / 10 }}
															%
														</div>
													</template>
												</el-table-column>
												<el-table-column prop="grade" label="Grade">
												</el-table-column>
											</el-table>
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Reports </el-col>
						<el-col :span="12">
							<!-- {{ reports_designation.length }} Designations -->
							<span v-for="(item, idx) in designationItems" :key="idx">
								<span
									v-for="(item1, idx1) in reports_designation.slice(0, 5)"
									:key="idx1"
								>
									<span v-if="item.id == item1 ? item.name : null">
										<el-tag
											class="mr-3"
											size="small"
											style="
												border-radius: 12px;
												text-align: center;
												border-color: #f9a168;
												background-color: #fff9f4;
												color: black;
												margin-bottom: 10px;
											"
											>{{ item.name }}
										</el-tag>
									</span>
								</span>
							</span>
						</el-col>
						<el-popover
							placement="right-start"
							title="Designation List"
							width="300"
							trigger="hover"
						>
							<div
								slot="reference"
								style="word-break: break-word; line-height: 120%"
								v-text="`+${reports_designation.length - 5} Others`"
							></div>
							<div
								v-for="(item, idx) in reports_designation.map((elem) =>
									designationItems.find((el) => elem === el.id)
								)"
								:key="idx"
							>
								{{ item ? (item.name ? item.name : "") : "" }} <br />
							</div>
						</el-popover>
					</el-row>

					<el-row style="margin-top: 10px">
						<el-col :span="4" :offset="1"> </el-col>
						<el-col :span="18">
							<div>
								<b>Total - </b> {{ reports_designation.length }} Designations
							</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Notifications </el-col>
						<el-col :span="12">
							<!-- {{ notification_designation.length }} Designations -->
							<span v-for="(item, idx) in designationItems" :key="idx">
								<span
									v-for="(item1, idx1) in notification_designation.slice(0, 5)"
									:key="idx1"
								>
									<span v-if="item.id == item1 ? item.name : null">
										<el-tag
											class="mr-3"
											size="small"
											style="
												border-radius: 12px;
												text-align: center;
												border-color: #f9a168;
												background-color: #fff9f4;
												color: black;
												margin-bottom: 10px;
											"
											>{{ item.name }}
										</el-tag>
									</span>
								</span>
							</span>
						</el-col>
						<el-popover
							placement="right-start"
							title="Designation List"
							width="300"
							trigger="hover"
						>
							<div
								slot="reference"
								style="word-break: break-word; line-height: 120%"
								v-text="`+${notification_designation.length - 5} Others`"
							></div>
							<div
								v-for="(item, idx) in notification_designation.map((elem) =>
									designationItems.find((el) => elem === el.id)
								)"
								:key="idx"
							>
								{{ item ? (item.name ? item.name : "") : "" }} <br />
							</div>
						</el-popover>
					</el-row>

					<el-row style="margin-top: 10px">
						<el-col :span="4" :offset="1"> </el-col>
						<el-col :span="18">
							<div>
								<b>Total - </b>
								{{ notification_designation.length }} Designations
							</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Trigger Notification </el-col>
						<el-col :span="4">
							<el-checkbox
								v-model="project_start_check"
								label="Project Start"
							></el-checkbox>
						</el-col>
					</el-row>
					<el-row style="margin-top: 30px">
						<el-col :span="4" :offset="1"> Reports </el-col>
						<el-col :span="4"
							>{{ before_start }} {{ before_start_category }} before Project
							Starts</el-col
						>
						<el-col :span="4">
							{{ before_ends }} {{ before_ends_category }} before Project ends
						</el-col>
					</el-row>
					<!-- <el-row style="margin-top: 30px">
					<el-col :span="23">
						For project which is set for a current date, show process is running
						in the background and it will be live in sometime. User should get a
						communication once the project is live
					</el-col>
				</el-row> -->
					<el-row style="margin-top: 60px; margin-bottom: 30px">
						<el-col
							style="margin-top: -10px"
							v-if="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
							"
							:span="2"
							:offset="16"
						>
							<el-button
								@click="go_back()"
								class="button-class-white2"
								style="border: none"
							>
								Cancel
							</el-button>
						</el-col>
						<el-col
							style="margin-top: -10px; margin-right: 0px"
							:span="2"
							:offset="
								active_view == 'CREATE_PROJECT' || active_view == 'EDIT_PROJECT'
									? 0
									: 18
							"
						>
							<el-button @click="prevStep(5)" class="button-class-white2">
								Back
							</el-button>
						</el-col>
						<!-- <el-col :span="4" style="margin-right: 0px">
						<el-button
							class="button-class-white-dialog"
							style="width: 200px; max-width: 200px"
						>
							Save As Draft
						</el-button>
					</el-col> -->
						<el-col style="margin-top: -50px" :span="2">
							<el-button
								@click="create_project()"
								class="button-class"
								style=""
							>
								Launch
							</el-button>
						</el-col>
					</el-row>
				</div>
			</el-card>
		</div>
		<orderFormProjectDialog
			@cancel="show_order_page = false"
			v-if="show_order_page"
			:storeFormObj="storeFormObj"
			:show_order_page="show_order_page"
			@set_serial_no="update_serial_no_form"
		/>
	</div>
</template>

<script>
import formBuilderServices from "../../../services/formBuilderServices";
import orderFormProjectDialog from "./OrderFormProjectDialog.vue";
var moment = require("moment");
export default {
	components: { orderFormProjectDialog },
	props: {
		title: String,
		active_view: String,
		storeObj: Object,
	},
	data: () => ({
		show_order_page: false,
		storeFormObj: {},
		datePickerOptions: {
			disabledDate(date) {
				return date < moment().subtract(1, "days");
			},
		},
		selectedAction: "applicable",
		raiseAction: "applicable",
		openActions: "project_can_be_completed",
		uploadFiles: "mandatory",
		before_start: "",
		before_start_category: [],
		before_ends: "",
		before_ends_category: [],
		createProjectItems: [
			{ name: "Project Information", active: true },
			{ name: "Assignment", active: false },
			{ name: "Grades", active: false },
			{ name: "Actions", active: false },
			{ name: "Reporting and Notifications", active: false },
			{ name: "Launch", active: false },
		],
		project_title: "",
		category: "",
		categoryItems: [],
		form: [],
		formItems: [],
		critical: null,
		criticalItems: [
			{ name: "Yes", value: true },
			{ name: "No", value: false },
		],
		allowedOn: "",
		allowedOnItems: [
			{ name: "All", value: "all" },
			{ name: "Only Mobile", value: "mobile" },
			{ name: "Only Web", value: "web" },
		],
		start_date: "",
		end_date: "",
		never: false,
		frequencyItems: [
			{ name: "Daily", value: "daily" },
			{ name: "Weekly", value: "weekly" },
			{ name: "Monthly", value: "monthly" },
			{ name: "Quarterly", value: "quarterly" },
			{ name: "Biennially", value: "biennially" },
			{ name: "One Time", value: "one_time" },
			{ name: "Anytime", value: "anytime" }
		],
		frequency: "",
		day_month: "",
		day_monthItems: [],
		daily_radio: "anytime",
		weekly_radio: "anyday_in_the_week",
		monthly_radio: "anytime_of_the_month",
		start_time: "",
		end_time: "",
		assign_radio: "1",
		locations: [],
		locationItems: [],
		team_radio: "",
		location_business: "",
		location_businessItems: [],
		designation: [],
		notification_designation: [],
		designationItems: [],
		reports_designation: [],
		employeeName: "",
		employeeNameItems: [],
		reports: "",
		reportsItems: [],
		notifications_radio: "1",
		reminder_radio: "1",
		grades_radio: "1",
		totalPoints: "",
		from_score: "",
		from_scoreItems: [],
		grade: "",
		gradeItems: [],
		to_score: "",
		to_scroreItems: [],
		height: 0,
		tableData: [
			{
				category_selection: "1",
				form_selection: "1",
				critical_selection: "1",
				allowed_on_selection: "1",
				srno_selection: "1",
				editing: false,
				editable_icon: false,
				editable_icon_form: false,
				showEditIcon: false,
				showDropdown: false,
			},
		],

		to_scoreItems: [],
		project_start: true,
		project_completed: true,
		project_overdue: true,
		project_start_check: true,
		tableData1: [],
		tableData_daily_radio: [
			{
				start_time_selection: "1",
				end_time_selection: "1",
				srno_selection: "1",
				editing: false,
			},
		],
		weekly_day: "",
		weekly_dayItems: [
			{ name: "Monday", value: "monday" },
			{ name: "Tuesday", value: "tuesday" },
			{ name: "Wednesday", value: "wednesday" },
			{ name: "Thursday", value: "thursday" },
			{ name: "Friday", value: "friday" },
			{ name: "Saturday", value: "saturday" },
			{ name: "Sunday", value: "sunday" },
		],
		weekly_frequency: "",
		weekly_frequencyItems: [
			{ name: "Anytime", value: "anytime" },
			{ name: "Fixed Time", value: "specific_time" },
		],
		monthly_frequency: "",
		monthly_frequencyItems: [
			{ name: "Anytime", value: "anytime" },
			{ name: "Fixed Time", value: "specific_time" },
		],
		tableData_weekly_radio: [
			{
				day_selection: "1",
				frequency_selection: "1",
				start_time_selection: "1",
				end_time_selection: "1",
				srno_selection: "1",
			},
		],
		monthly_day: "",
		monthly_dayItems: [],
		tableData_monthly_radio: [
			{
				frequency_selection: "1",
				start_time_selection: "1",
				end_time_selection: "1",
				srno_selection: "1",
				day_selection: "1",
			},
		],
		months: [],
		monthsItems: [
			{ name: "January", value: "jan" },
			{ name: "February", value: "feb" },
			{ name: "March", value: "mar" },
			{ name: "April", value: "apr" },
			{ name: "May", value: "may" },
			{ name: "June", value: "jun" },
			{ name: "July", value: "jul" },
			{ name: "August", value: "aug" },
			{ name: "September", value: "sep" },
			{ name: "October", value: "oct" },
			{ name: "November", value: "nov" },
			{ name: "December", value: "dec" },
		],
		monthly_start_day: "",
		monthly_end_day: "",
		daily_show: false,
		weekly_show: false,
		monthly_show: false,
		months_selection: "",
		months_selectionItems: [
			{ name: "All", value: "all" },
			{ name: "Select Months", value: "select_months" },
		],
		range_show: false,
		tableData_range: [
			{
				srno_selection: "1",
				from_score_selection: "1",
			},
		],
		before_start_categoryItems: [
			{ name: "minutes", value: "minutes" },
			{ name: "hours", value: "hours" },
			{ name: "days", value: "days" },
		],
		from_scoreItemsNew: [],
		serialNumberItems: [],
		from_scoreItems_decimal: [],
		from_score_decimal: "",
		to_score_decimal: "",
		designationItemsNA: [],
		tableEditing: false,
		repeat: null,
		repeatItems: [
			{ name: "Every Week", value: 1 },
			{ name: "Every 2 Weeks", value: 2 },
		],
		days_for_due_date: 7,
		days_for_due_dateItems: [],
		project_sign_off: "no",
		signature_required: false,
		auditee_designation: [],
		to_be_completed_by: [],
		approvalRequired: "Yes",
		approval_by: [],
		autoApproveDays: 7,
	}),
	computed: {
		getTotal() {
			console.log(this.tableData, "tableData");
			let formcount = 0;
			this.tableData.forEach((el) => {
				formcount += el.form_length;
			});
			console.log(formcount, "fc");
			return formcount.toString();
		},
		getPoints() {
			let points = 0;
			this.tableData.forEach((el) => {
				points += el.points;
			});
			console.log(points, "points");
			return points.toString();
		},
		fromDatePickerOptions() {
			return {
				firstDayOfWeek: 1,
				disabledDate: this.disableFromDatePickerDates,
			};
		},
	},
	watch: {
		// tableData: {
		// 	handler() {
		// 		this.$nextTick(() => {
		// 			// Update getTotal when tableData changes
		// 			console.log("coming here");
		// 			this.getTotal;
		// 			this.getPoints;
		// 		});
		// 	},
		// 	deep: true,
		// },
		start_date(val) {
			console.log(val, "sd");
			console.log(moment(val).format("YYYY-MM-DD"));
		},
		never() {
			this.end_date = "";
		},
	},
	created() {
		this.list_all_categories();
	},
	mounted() {
		console.log(this.storeObj, "saduqheibwqe iv");
		this.moment = moment;
		this.get_dates();
		this.gradeItems = [];
		this.from_scoreItems = [];
		this.from_scoreItemsNew = [];
		this.selectedAction = this.storeObj.auto_actions_applicable
			? "applicable"
			: "not_applicable";
		this.raiseAction = this.storeObj.manual_actions_applicable
			? "applicable"
			: "not_applicable";
		this.openActions =
			this.storeObj.on_actions_open == "close_project"
				? "project_can_be_completed"
				: "project_on_hold";
		this.uploadFiles = this.storeObj.actions_attachment_mandatory
			? "mandatory"
			: "optional";

		for (let i = 65; i <= 90; i++) {
			this.gradeItems.push({
				name: String.fromCharCode(i),
				value: String.fromCharCode(i),
				disabled: false,
			});
		}
		this.gradeItems.push({
			name: "Fail",
			value: "Fail",
			disabled: false,
		});
		for (let i = 0; i <= 100; i++) {
			this.from_scoreItems.push({
				name: i,
				value: i,
			});
			this.from_scoreItemsNew.push({
				name: i,
				value: i,
			});
		}
		for (let i = 0; i < 1; i += 0.01) {
			this.from_scoreItems_decimal.push({
				name: i.toFixed(2),
				value: i.toFixed(2),
			});
		}
		this.from_score_decimal = "0.00";
		this.to_score_decimal = "0.99";
		for (let i = 1; i <= 30; i++) {
			this.days_for_due_dateItems.push({
				name: i + `${i == 1 ? " day" : " days"}`,
				id: i,
			});
		}
		this.list_locations();
		this.list_designations();
		if (this.storeObj.action == "EDIT") {
			this.tableData = [];
			console.log("storeObj", this.storeObj);
			this.project_sign_off = this.storeObj.project_sign_off_required
				? "yes"
				: "no";
			this.signature_required = this.storeObj.auditor_sign_required;
			this.auditee_designation = this.storeObj.auditee_designations;

			this.project_title = this.storeObj.project_info.name;
			// this.tableData = this.storeObj.execution_category_mappings_list;
			for (
				let i = 0;
				i < this.storeObj.execution_category_mappings_list.length;
				i++
			) {
				this.tableData.push({
					srno: i + 1,
					category_id:
						this.storeObj.execution_category_mappings_list[i].form_category,
					form: this.storeObj.execution_category_mappings_list[i].forms,
					form_length:
						this.storeObj.execution_category_mappings_list[i].forms.length,
					critical:
						this.storeObj.execution_category_mappings_list[i].is_critical,
					allowedon:
						this.storeObj.execution_category_mappings_list[i].allowed_on,
					points:
						this.storeObj.execution_category_mappings_list[i].total_points,
					category: "",
					id: this.storeObj.execution_category_mappings_list[i].id,
					editable_icon: false,
					editable_icon_form: false,

					showEditIcon: false,
					showDropdown: false,
				});
			}
			console.log(this.tableData, "tableData");
			formBuilderServices.listAllCategory().then((res) => {
				this.categoryItems = JSON.parse(res.data);
				for (let j = 0; j < this.tableData.length; j++) {
					for (let i = 0; i < this.categoryItems.length; i++) {
						if (this.tableData[j].category_id == this.categoryItems[i].id) {
							this.tableData[j].category = this.categoryItems[i].name;
						}
					}
				}
			});
			this.$forceUpdate();
			console.log(this.tableData, "this.tableData");
			this.start_date = this.storeObj.validity_start_date;
			this.never = this.storeObj.validity_never_ends;
			this.end_date = this.never ? "" : this.storeObj.validity_end_date;
			this.frequency = this.storeObj.frequency;
			if (this.frequency == "daily") {
				this.daily_radio = this.storeObj.daily_schedule_plan;
				if (this.daily_radio == "specific_time") {
					this.tableData_daily_radio = [];
					for (
						let i = 0;
						i < this.storeObj.daily_schedule_times_list.length;
						i++
					) {
						this.tableData_daily_radio.push({
							srno: i + 1,
							start_time: this.storeObj.daily_schedule_times_list[
								i
							].start_time.slice(0, -3),
							end_time: this.storeObj.daily_schedule_times_list[
								i
							].end_time.slice(0, -3),
							id: this.storeObj.daily_schedule_times_list[i].id,
						});
					}
				}
			}
			if (this.frequency == "weekly") {
				this.weekly_radio = this.storeObj.weekly_schedule_plan;
				if (this.weekly_radio == "specific_day_in_a_week") {
					this.tableData_weekly_radio = [];
					for (
						let i = 0;
						i < this.storeObj.weekly_schedule_days_list.length;
						i++
					) {
						this.tableData_weekly_radio.push({
							srno: i + 1,
							day: this.storeObj.weekly_schedule_days_list[i].day,
							start_time: this.storeObj.weekly_schedule_days_list[
								i
							].start_time.slice(0, -3),
							end_time: this.storeObj.weekly_schedule_days_list[
								i
							].end_time.slice(0, -3),
							frequency: this.storeObj.weekly_schedule_days_list[i].frequency,
							id: this.storeObj.weekly_schedule_days_list[i].id,
						});
					}
					console.log("tableData_weekly_radio", this.tableData_weekly_radio);
				}
				if (this.weekly_radio == "anyday_in_the_week") {
					this.repeat = this.storeObj.weekly_repeat;
				}
			}
			if (this.frequency == "monthly") {
				this.monthly_radio = this.storeObj.monthly_schedule_plan;
				this.months = this.storeObj.months_list;
				if (this.months.length == 12) {
					this.months_selection = "all";
				} else {
					this.months_selection = "select_months";
				}
				if (this.monthly_radio == "date_of_the_month") {
					this.tableData_monthly_radio = [];
					for (
						let i = 0;
						i < this.storeObj.monthly_schedule_dates_list.length;
						i++
					) {
						this.tableData_monthly_radio.push({
							srno: i + 1,
							day: this.storeObj.monthly_schedule_dates_list[i].day,
							start_time: this.storeObj.monthly_schedule_dates_list[
								i
							].start_time.slice(0, -3),
							end_time: this.storeObj.monthly_schedule_dates_list[
								i
							].end_time.slice(0, -3),
							frequency: this.storeObj.monthly_schedule_dates_list[i].frequency,
							id: this.storeObj.monthly_schedule_dates_list[i].id,
						});
					}
				}
				if (this.monthly_radio == "for_a_date_range") {
					this.monthly_start_day = this.storeObj.date_range_start;
					this.monthly_end_day = this.storeObj.date_range_end;
				}
			}
			this.assign_radio = this.storeObj.assign_by == "location" ? "1" : "2";

			this.grades_radio = this.storeObj.are_grades_applicable ? "1" : "2";
			if (this.grades_radio == "1") {
				this.tableData_range = [];
				for (let i = 0; i < this.storeObj.grades_list.length; i++) {
					this.tableData_range.push({
						srno: i + 1,
						from_score: this.storeObj.grades_list[i].range_start,
						// from_score_decimal: this.storeObj.grades_list[i].range_start
						// 	.toString()
						// 	.includes(".")
						// 	? this.storeObj.grades_list[i].range_start.split(".")[1]
						// 	: "0.00",
						// to_score_decimal: this.storeObj.grades_list[i].range_end
						// 	.toString()
						// 	.includes(".")
						// 	? this.storeObj.grades_list[i].range_end.split(".")[1]
						// 	: "0.99",
						to_score: this.storeObj.grades_list[i].range_end,
						grade: this.storeObj.grades_list[i].grade,
						id: this.storeObj.grades_list[i].id,
					});
				}
			}

			this.project_start = this.storeObj.notification_on_project_start;
			this.project_completed = this.storeObj.notification_on_project_completed;
			this.project_overdue = this.storeObj.notification_on_project_overdue;
			let start = this.storeObj.reminder_before_project_starts.split(":");
			let end = this.storeObj.reminder_before_project_ends.split(":");
			console.log(start, "start");
			if (start[0].includes(" ")) {
				this.before_start = start[0].split(" ")[0];
				this.before_start_category = "days";
				console.log("day");
			} else {
				this.before_start = start[0] == "00" ? start[1] : start[0];
				this.before_start_category = start[0] != "00" ? "minutes" : "hours";
			}
			if (end[0].includes(" ")) {
				console.log("day");
				this.before_ends = end[0].split(" ")[0];
				this.before_ends_category = "days";
			} else {
				this.before_ends = end[0] == "00" ? end[1] : end[0];
				this.before_ends_category = end[0] != "00" ? "minutes" : "hours";
			}
			console.log("this.before_start", this.before_start);
			this.days_for_due_date = this.storeObj.days_for_due_date;
			this.autoApproveDays = this.storeObj.auto_approve_days;
			this.to_be_completed_by = this.storeObj.actions_to_be_completed_by;
			this.approval_by = this.storeObj.actions_approval_by;
			this.approvalRequired = this.storeObj.actions_approval_required
				? "Yes"
				: "No";
		}
		let serialNumberItems = [];
		for (let i = 0; i < this.tableData.length; i++) {
			serialNumberItems.push({ name: i + 1, value: i + 1 });
		}
		this.serialNumberItems = serialNumberItems;
	},
	methods: {
		update_due_date() {
			this.$forceUpdate();
		},
		update_serial_no_form(formItems, storeFormObj, allFormItems) {
			console.log(
				formItems,
				storeFormObj,
				allFormItems,
				"storeFormObjstoreFormObjstoreFormObj"
			);
			this.formItems = [];
			this.form = [];
			const mergedArray = [
				...formItems.map((item) => ({
					...item,
				})),
				...allFormItems.filter(
					(item) => !formItems.some((fItem) => fItem.id === item.id)
				),
			];
			this.formItems = mergedArray;
			this.form = formItems;
			console.log(
				mergedArray,
				this.formItems,
				this.form,
				"mergedArraymergedArray"
			);

			this.show_order_page = false;
		},
		notification_designation_setting() {
			if (this.notification_designation.length != 0) {
				let found = false;
				for (let i = 0; i < this.notification_designation.length; i++) {
					if (this.notification_designation[i] == "Not Applicable") {
						found = true;
					}
				}
				if (found) {
					this.notification_designation = this.notification_designation.filter(
						(el) => el == "Not Applicable"
					);
				}
			}
		},
		reports_designation_setting() {
			if (this.reports_designation.length != 0) {
				let found = false;
				for (let i = 0; i < this.reports_designation.length; i++) {
					if (this.reports_designation[i] == "Not Applicable") {
						found = true;
					}
				}
				if (found) {
					this.reports_designation = this.reports_designation.filter(
						(el) => el == "Not Applicable"
					);
				}
			}
		},
		cancel_change_serial_number(item, idx) {
			item.showDropdown = false;
			item.showEditIcon = false;
			item.srno = item.old_serial_no;
			this.$forceUpdate();
			return item;
		},
		success_change_serial_number(item, idx) {
			console.log(idx, "idx");
			item.showDropdown = false;
			item.showEditIcon = false;
			let arr1 = this.tableData.splice(idx, 1);
			this.insertArrayAt(this.tableData, item.srno - 1, arr1);
			this.tableData.forEach((el, index) => {
				el.srno = index + 1;
			});
			this.$forceUpdate();
			return item;
		},
		insertArrayAt(array, index, arrayToInsert) {
			Array.prototype.splice.apply(array, [index, 0].concat(arrayToInsert));
			return array;
		},
		change_serial_number(item, idx, event) {
			if (event == true) item.old_serial_no = item.srno;
			this.$forceUpdate();
			return item;
		},
		show_edit_icon(item) {
			item.editable_icon = true;
			console.log("show_edit_icon", item);

			// console.log(item, "irem");
			this.$forceUpdate();
			return item;
		},
		show_edit_icon_form(item) {
			item.editable_icon_form = true;
			console.log("show_edit_icon", item);

			// console.log(item, "irem");
			this.$forceUpdate();
			return item;
		},
		hide_edit_icon_form(item) {
			// console.log("hide_edit_icon");
			item.editable_icon_form = false;
			this.$forceUpdate();

			return item;
		},
		hide_edit_icon(item) {
			// console.log("hide_edit_icon");
			item.editable_icon = false;
			this.$forceUpdate();

			return item;
		},
		show_dropdown(item) {
			item.old_serial_no = item.srno;
			console.log(item, "items");
			item.showDropdown = true;
			this.$forceUpdate();

			return item;
		},
		openDialogForm(item) {
			this.storeFormObj = {};
			this.storeFormObj = item;
			item.editable_icon_form = false;
			this.show_order_page = true;
		},
		select_all(type) {
			switch (type) {
				case "location":
					let locations = [];
					for (let i = 0; i < this.locationItems.length; i++) {
						locations.push(this.locationItems[i].id);
					}
					this.locations = locations;
					this.$forceUpdate();
					break;
				case "designation":
					let designation = [];
					for (let i = 0; i < this.designationItems.length; i++) {
						designation.push(this.designationItems[i].id);
					}
					this.designation = designation;
					this.$forceUpdate();
					break;

				case "reports":
					let reports_designation = [];
					for (let i = 0; i < this.designationItems.length; i++) {
						reports_designation.push(this.designationItems[i].id);
					}
					this.reports_designation = reports_designation;
					this.$forceUpdate();
					break;

				case "auditee":
					let auditee_designation = [];
					for (let i = 0; i < this.designationItems.length; i++) {
						auditee_designation.push(this.designationItems[i].id);
					}
					this.auditee_designation = auditee_designation;
					this.$forceUpdate();
					break;

				case "notification":
					let notification_designation = [];
					for (let i = 0; i < this.designationItems.length; i++) {
						notification_designation.push(this.designationItems[i].id);
					}
					this.notification_designation = notification_designation;
					this.$forceUpdate();
					break;
				case "approval_by":
					let approval_by = [];
					for (let i = 0; i < this.designationItems.length; i++) {
						approval_by.push(this.designationItems[i].id);
					}
					this.approval_by = approval_by;
					this.$forceUpdate();
					break;
				case "to_be_completed_by":
					let to_be_completed_by = [];
					for (let i = 0; i < this.designationItems.length; i++) {
						to_be_completed_by.push(this.designationItems[i].id);
					}
					this.to_be_completed_by = to_be_completed_by;
					this.$forceUpdate();
					break;
				default:
					break;
			}
		},
		clear_all(type) {
			switch (type) {
				case "location":
					let locations = [];
					this.locations = locations;
					this.$forceUpdate();
					break;
				case "designation":
					let designation = [];
					this.designation = designation;
					this.$forceUpdate();
					break;
				case "reports":
					let reports_designation = [];
					this.reports_designation = reports_designation;
					this.$forceUpdate();
					break;
				case "auditee":
					let auditee_designation = [];
					this.auditee_designation = auditee_designation;
					this.$forceUpdate();
					break;
				case "notification":
					let notification_designation = [];
					this.notification_designation = notification_designation;
					this.$forceUpdate();
					break;
				case "approval_by":
					let approval_by = [];
					this.approval_by = approval_by;
					this.$forceUpdate();
					break;
				case "to_be_completed_by":
					let to_be_completed_by = [];
					this.to_be_completed_by = to_be_completed_by;
					this.$forceUpdate();
					break;

				default:
					break;
			}
		},
		getDesignationItemsAllNotification() {
			console.log(this.notification_designation, "is");
			let found = null;
			for (let j = 0; j < this.notification_designation.length; j++) {
				if (this.notification_designation[j] == "All") {
					found = true;
				}
			}
			if (found) {
				let notification_designation = [];
				for (let i = 0; i < this.designationItems.length; i++) {
					notification_designation.push(this.designationItems[i].id);
				}
				console.log(notification_designation, "lis");
				this.notification_designation = notification_designation;
				this.$forceUpdate();
			}
		},
		getDesignationItemsAllReports() {
			console.log(this.reports_designation, "is");
			let found = null;
			for (let j = 0; j < this.reports_designation.length; j++) {
				if (this.reports_designation[j] == "All") {
					found = true;
				}
			}
			if (found) {
				let reports_designation = [];
				for (let i = 0; i < this.designationItems.length; i++) {
					reports_designation.push(this.designationItems[i].id);
				}
				console.log(reports_designation, "lis");
				this.reports_designation = reports_designation;
				this.$forceUpdate();
			}
		},
		getDesignationItemsAll() {
			console.log(this.designation, "is");
			let found = null;
			for (let j = 0; j < this.designation.length; j++) {
				if (this.designation[j] == "All") {
					found = true;
				}
			}
			if (found) {
				let designation = [];
				for (let i = 0; i < this.designationItems.length; i++) {
					designation.push(this.designationItems[i].id);
				}
				console.log(designation, "lis");
				this.designation = designation;
				this.$forceUpdate();
			}
		},
		getLocationItemsAll() {
			console.log(this.locations, "is");
			let found = null;
			for (let j = 0; j < this.locations.length; j++) {
				if (this.locations[j] == "All") {
					found = true;
				}
			}
			if (found) {
				let locations = [];
				for (let i = 0; i < this.locationItems.length; i++) {
					locations.push(this.locationItems[i].id);
				}
				console.log(locations, "lis");
				this.locations = locations;
				this.$forceUpdate();
			}
		},
		all_form_items(idx, item) {
			let points = 0;
			console.log(this.formItems, "this.formItems");
			for (let i = 0; i < this.formItems.length; i++) {
				if (
					this.formItems[i].scoring_type &&
					this.formItems[i].scoring_type != "not_applicable"
				) {
					points += this.formItems[i].total_points;
				}
			}
			this.tableData[idx].points = points;
			let form = [];
			for (let i = 0; i < this.form.length; i++) {
				if (this.form[i] == "All") {
					for (let i = 0; i < this.formItems.length; i++) {
						if (this.formItems[i].id != "All") {
							form.push(this.formItems[i].id);
						}
					}
					this.form = form;
				}
			}
		},
		disableFromDatePickerDates(date) {
			if (!this.start_date) {
				return false;
			}
			return date <= this.start_date;
		},
		go_to_launch() {
			this.$emit("closed");
		},
		go_to_forms() {
			this.$emit("close");
		},
		go_back() {
			this.$emit("close");
		},
		disable_option(val) {
			for (
				let i = this.monthly_dayItems.length - 4;
				i < this.monthly_dayItems.length;
				i++
			) {
				this.monthly_dayItems[i].disabled = true;
			}
			this.$forceUpdate();
			console.log(this.monthly_dayItems, "monthly_dayItems");
		},
		get_dates() {
			const nth = function (d) {
				const dString = String(d);
				const last = +dString.slice(-2);
				if (last > 3 && last < 21) return "th";
				switch (last % 10) {
					case 1:
						return "st";
					case 2:
						return "nd";
					case 3:
						return "rd";
					default:
						return "th";
				}
			};
			// test
			let numbers = [...Array(32).keys()].map((i) => ({
				name: `${i}${nth(i)}`,
				value: i,
				disabled: false,
			}));
			numbers.shift();
			console.log(numbers);
			this.monthly_dayItems = numbers;
		},
		prevStep(val) {
			for (let i = 0; i < this.createProjectItems.length; i++) {
				this.createProjectItems[i].active = false;
			}
			this.createProjectItems[val - 1].active = true;
		},
		create_project() {
			let execution_array = [];
			for (let i = 0; i < this.tableData.length; i++) {
				console.log(this.tableData[i]);
				if (this.tableData[i].id) {
					execution_array.push({
						form_category: this.tableData[i].category_id,
						forms: this.tableData[i].form,
						is_critical: false,
						allowed_on: this.tableData[i].allowedon,
						id: this.tableData[i].id,
						points: this.tableData[i].points,
					});
				} else {
					execution_array.push({
						form_category: this.tableData[i].category_id,
						forms: this.tableData[i].form,
						is_critical: false,
						allowed_on: this.tableData[i].allowedon,
						points: this.tableData[i].points,
					});
				}
			}
			// for (let i = 0; i < this.locations.length; i++) {
			// 	if (this.locations[i] == "All") {
			// 		delete this.locations[i];
			// 	}
			// }
			// for (let i = 0; i < this.designation.length; i++) {
			// 	if (this.designation[i] == "All") {
			// 		delete this.designation[i];
			// 	}
			// }
			for (let i = 0; i < this.notification_designation.length; i++) {
				if (this.notification_designation[i] == "Not Applicable") {
					this.notification_designation = [];
				}
			}

			for (let i = 0; i < this.reports_designation.length; i++) {
				if (this.reports_designation[i] == "Not Applicable") {
					this.reports_designation = [];
				}
			}
			console.log(this.locations, "this.locations");
			const mappedIds = this.locations.map((el) => el.id);
			const idExists = this.locations.some(
				(el) => el.hasOwnProperty("id") 
			);
			let LocationResult;
			if (idExists) {
				LocationResult = mappedIds;
			} else {
				LocationResult = this.locations;
			}
			let params = {
				project: {
					name: this.project_title,
				},

				execution_setup: {
					auto_approve_days: this.autoApproveDays,
					actions_to_be_completed_by: this.to_be_completed_by,
					actions_approval_by: this.approval_by,
					actions_approval_required:
						this.approvalRequired == "Yes" ? true : false,
					project_sign_off_required:
						this.project_sign_off == "yes" ? true : false,
					auditor_sign_required: this.signature_required,
					auditee_designations: this.auditee_designation,
					days_for_due_date: this.days_for_due_date,
					auto_actions_applicable:
						this.selectedAction == "applicable" ? true : false,
					manual_actions_applicable:
						this.raiseAction == "applicable" ? true : false,
					actions_attachment_mandatory:
						this.uploadFiles == "mandatory" ? true : false,
					on_actions_open:
						this.openActions == "project_can_be_completed"
							? "close_project"
							: "hold_project",
					execution_type: "project",
					assign_to: "designation",
					assign_by: "location",
					designations: this.designation,
					locations: LocationResult,
					validity_start_date: moment(this.start_date).format("YYYY-MM-DD"),
					validity_end_date: this.never
						? null
						: moment(this.end_date).format("YYYY-MM-DD"),
					validity_never_ends: this.never,
					frequency: this.frequency,
					daily_schedule_plan: "anytime",
					weekly_schedule_plan: "anyday_in_the_week",
					monthly_schedule_plan: "anytime_of_the_month",
					months_list: ["jan"],
					date_range_start: 1,
					date_range_end: 1,
					are_grades_applicable: this.grades_radio == "1" ? true : false,
					notification_designations: this.notification_designation,
					report_designations: this.reports_designation,
					notification_on_project_start: this.project_start,
					notification_on_project_completed: this.project_completed,
					notification_on_project_overdue: this.project_overdue,
					reminder_before_project_starts:
						this.before_start_category == "minutes"
							? `00:${this.before_start}:00`
							: this.before_start_category == "hours"
							? `${this.before_start}:00:00`
							: this.before_start_category == "days"
							? `${this.before_start} day 00:00:00`
							: "00:00:00",
					reminder_before_project_ends:
						this.before_ends_category == "minutes"
							? `00:${this.before_ends}:00`
							: this.before_ends_category == "hours"
							? `${this.before_ends}:00:00`
							: this.before_ends_category == "days"
							? `${this.before_ends} day 00:00:00`
							: "00:00:00",
				},
				execution_category_mappings: execution_array,
				daily_schedule_times: [],
				week_schedule_days: [],
				month_schedule_dates: [],
				grades: [],
			};
			if (this.storeObj.action == "EDIT") {
				params.project.id = this.storeObj.project_info.id;
				params.execution_setup.id = this.storeObj.id;
			}
			if (this.frequency == "daily") {
				params.execution_setup.daily_schedule_plan = this.daily_radio;
				if (this.daily_radio == "specific_time") {
					for (let i = 0; i < this.tableData_daily_radio.length; i++) {
						if (this.tableData_daily_radio[i].id) {
							params.daily_schedule_times.push({
								start_time: this.tableData_daily_radio[i].start_time + ":00",
								end_time: this.tableData_daily_radio[i].end_time + ":00",
								id: this.tableData_daily_radio[i].id,
							});
						} else {
							params.daily_schedule_times.push({
								start_time: this.tableData_daily_radio[i].start_time + ":00",
								end_time: this.tableData_daily_radio[i].end_time + ":00",
							});
						}
					}
				}
			}
			if (this.frequency == "weekly") {
				params.execution_setup.weekly_schedule_plan = this.weekly_radio;
				if (this.weekly_radio == "specific_day_in_a_week") {
					for (let i = 0; i < this.tableData_weekly_radio.length; i++) {
						if (this.tableData_weekly_radio[i].id) {
							params.week_schedule_days.push({
								day: this.tableData_weekly_radio[i].day,
								frequency: this.tableData_weekly_radio[i].frequency,
								start_time:
									this.tableData_weekly_radio[i].frequency == "anytime"
										? "00:00:00"
										: this.tableData_weekly_radio[i].start_time + ":00",
								end_time:
									this.tableData_weekly_radio[i].frequency == "anytime"
										? "00:00:00"
										: this.tableData_weekly_radio[i].end_time + ":00",
								id: this.tableData_weekly_radio[i].id,
							});
						} else {
							params.week_schedule_days.push({
								day: this.tableData_weekly_radio[i].day,
								frequency: this.tableData_weekly_radio[i].frequency,
								start_time:
									this.tableData_weekly_radio[i].frequency == "anytime"
										? "00:00:00"
										: this.tableData_weekly_radio[i].start_time + ":00",
								end_time:
									this.tableData_weekly_radio[i].frequency == "anytime"
										? "00:00:00"
										: this.tableData_weekly_radio[i].end_time + ":00",
							});
						}
					}
				}
				if (this.weekly_radio == "anyday_in_the_week") {
					params.execution_setup.weekly_repeat = this.repeat;
				}
			}
			if (this.frequency == "monthly") {
				params.execution_setup.monthly_schedule_plan = this.monthly_radio;
				params.execution_setup.months_list =
					this.months_selection == "all"
						? this.monthsItems.map((el) => el.value)
						: this.months;
				if (this.monthly_radio == "for_a_date_range") {
					params.execution_setup.date_range_start = this.monthly_start_day;
					params.execution_setup.date_range_end = this.monthly_end_day;
				}
				if (this.monthly_radio == "date_of_the_month") {
					for (let i = 0; i < this.tableData_monthly_radio.length; i++) {
						if (this.tableData_monthly_radio[i].id) {
							params.month_schedule_dates.push({
								day: this.tableData_monthly_radio[i].day,
								frequency: this.tableData_monthly_radio[i].frequency,
								start_time:
									this.tableData_monthly_radio[i].frequency == "anytime"
										? "00:00:00"
										: this.tableData_monthly_radio[i].start_time + ":00",
								end_time:
									this.tableData_monthly_radio[i].frequency == "anytime"
										? "00:00:00"
										: this.tableData_monthly_radio[i].end_time + ":00",
								id: this.tableData_monthly_radio[i].id,
							});
						} else {
							params.month_schedule_dates.push({
								day: this.tableData_monthly_radio[i].day,
								frequency: this.tableData_monthly_radio[i].frequency,
								start_time:
									this.tableData_monthly_radio[i].frequency == "anytime"
										? "00:00:00"
										: this.tableData_monthly_radio[i].start_time + ":00",
								end_time:
									this.tableData_monthly_radio[i].frequency == "anytime"
										? "00:00:00"
										: this.tableData_monthly_radio[i].end_time + ":00",
							});
						}
					}
				}
			}
			if (this.grades_radio == "1") {
				for (let i = 0; i < this.tableData_range.length; i++) {
					if (this.tableData_range[i].id) {
						params.grades.push({
							range_start: this.tableData_range[i].from_score,
							range_end: this.tableData_range[i].to_score,
							grade: this.tableData_range[i].grade,
							serial_no: this.tableData_range[i].srno,
							id: this.tableData_range[i].id,
						});
					}
					// else {
					// 	params.grades.push({
					// 		range_start: `${this.tableData_range[i].from_score}.${
					// 			this.tableData_range[i].from_score_decimal.split(".")[1]
					// 		}`,
					// 		range_end: `${this.tableData_range[i].to_score}.${
					// 			this.tableData_range[i].to_score_decimal.split(".")[1]
					// 		}`,
					// 		grade: this.tableData_range[i].grade,
					// 		serial_no: this.tableData_range[i].srno,
					// 	});
					// }
				}
			}
			formBuilderServices
				.addProject(params)
				.then((res) => {
					console.log(res, "create project");
					this.$notify.success({
						title: "Success",
						message: `${
							this.storeObj.action == "Edit"
								? "Project Edited Successfully"
								: "Project Created Successfully"
						}`,
						type: "Success",
					});
					if (
						this.active_view == "CREATE_PROJECT" ||
						this.active_view == "EDIT_PROJECT"
					)
						this.go_back();
					else this.go_to_forms();
				})
				.catch((err) => {
					// this.$notify.success({
					// 	title: "Success",
					// 	message: "Project Created Successfully",
					// 	type: "Success",
					// });
					// if (this.active_view == "CREATE_PROJECT") this.go_back();
					// else this.go_to_forms();
				});
		},
		list_locations() {
			formBuilderServices.listAllLocations().then((res) => {
				console.log(JSON.parse(res.data), "loc");
				this.locationItems = JSON.parse(res.data);
				// this.locationItems.unshift({ name: "All", id: "All" });
				if (this.storeObj.action == "EDIT") {
					if (this.locationItems.length == this.storeObj.locations.length - 1) {
						let locations = [];
						for (let i = 0; i < this.locationItems.length; i++) {
							locations.push(this.locationItems[i]);
						}
						// locations = locations.push("All");
						this.locations = locations;
						console.log("here cominf");
					} else {
						this.locations = this.storeObj.locations;
						console.log("here cominf here");
					}
					console.log(this.locations, "this.locations");
				}
			});
		},
		list_designations() {
			formBuilderServices.listAllDesignations().then((res) => {
				console.log(JSON.parse(res.data), "designat");
				this.designationItems = JSON.parse(res.data);
				this.designationItemsNA = JSON.parse(res.data);
				this.designationItemsNA.unshift({
					name: "Not Applicable",
					id: "Not Applicable",
				});
				// this.designationItems.unshift({ name: "All", id: "All" });

				// 	this.designation = this.storeObj.designations;
				// this.reports_designation = this.storeObj.report_designations;
				// this.notification_designation = this.storeObj.notification_designations;

				if (this.storeObj.action == "EDIT") {
					if (
						this.designationItems.length ==
						this.storeObj.designations.length - 1
					) {
						let designation = [];
						for (let i = 0; i < this.designationItems.length; i++) {
							designation.push(this.designationItems[i]);
						}
						// designation = designation.push("All");
						this.designation = designation;
					} else {
						this.designation = this.storeObj.designations;
					}

					if (
						this.designationItems.length ==
						this.storeObj.report_designations.length - 1
					) {
						let reports_designation = [];
						for (let i = 0; i < this.designationItems.length; i++) {
							reports_designation.push(this.designationItems[i]);
						}
						// reports_designation = reports_designation.push("All");
						this.reports_designation = reports_designation;
					} else {
						this.reports_designation =
							this.storeObj.report_designations.length == 0
								? ["Not Applicable"]
								: this.storeObj.report_designations;
					}
					// if(this.storeObj.report_designations.length==0){
					// 	this.reports_designation = 'Not Applicable'
					// }

					if (
						this.designationItems.length ==
						this.storeObj.notification_designations.length - 1
					) {
						let notification_designation = [];
						for (let i = 0; i < this.designationItems.length; i++) {
							notification_designation.push(this.designationItems[i]);
						}
						// notification_designation = notification_designation.push("All");
						this.notification_designation = notification_designation;
					} else {
						this.notification_designation =
							this.storeObj.notification_designations.length == 0
								? ["Not Applicable"]
								: this.storeObj.notification_designations;
					}
					console.log(
						"this.notification_designation",
						this.notification_designation
					);
					// if(this.storeObj.notification_designations.length==0){
					// 	this.notification_designation = 'Not Applicable'
					// }
				}
			});
		},
		get_values() {
			this.daily_radio = "anytime";
			this.weekly_radio = "anyday_in_the_week";
			this.monthly_radio = "anytime_of_the_month";
		},
		add_more(value, idx, item) {
			switch (value) {
				case 1:
					let category = "";
					let category_id = "";
					this.categoryItems.filter((el) => {
						if (el.id == this.category) {
							category = el.name;
							category_id = el.id;
						}
					});
					console.log(this.tableData[idx], "this.tableData before");
					this.tableData.splice(idx, 1, {
						srno: this.tableData[idx].editing
							? idx + 1
							: this.tableData.length,
						category: category,
						category_id: category_id,
						form: this.form,
						form_length: this.form.length,
						critical: this.critical,
						allowedon: this.allowedOn,
						points: this.tableData[idx].points,
						editable_icon: false,
						editable_icon_form: false,
						showEditIcon: false,
						showDropdown: false,
					});
					// this.tableData.push();
					this.tableEditing = false;
					this.category = "";
					this.form = [];
					this.critical = "";
					this.allowedOn = "";
					console.log("this.tableData", this.tableData);
					break;
				case 111:
					if (!this.tableData[this.tableData.length - 1].allowed_on_selection) {
						this.tableEditing = true;
						this.tableData.push({
							category_selection: "1",
							form_selection: "1",
							critical_selection: "1",
							allowed_on_selection: "1",
							srno_selection: "1",
						});
					}

					break;
				case 2:
					this.tableData_daily_radio.splice(
						this.tableData_daily_radio.length - 1,
						1
					);
					this.tableData_daily_radio.push({
						srno: this.tableData_daily_radio.length + 1,
						start_time: this.start_time,
						end_time: this.end_time,
					});
					this.start_time = "";
					this.end_time = "";
					break;
				case 3:
					this.tableData_weekly_radio.splice(
						this.tableData_weekly_radio.length - 1,
						1
					);
					this.tableData_weekly_radio.push({
						srno: this.tableData_weekly_radio.length + 1,
						day: this.weekly_day,
						start_time:
							this.weekly_frequency == "anytime" ? "" : this.start_time,
						end_time: this.weekly_frequency == "anytime" ? "" : this.end_time,
						frequency: this.weekly_frequency,
					});
					this.start_time = "";
					this.end_time = "";
					this.weekly_day = "";
					this.weekly_frequency = "";
					break;
				case 4:
					this.tableData_monthly_radio.splice(
						this.tableData_monthly_radio.length - 1,
						1
					);
					this.tableData_monthly_radio.push({
						srno: this.tableData_monthly_radio.length + 1,
						day: this.monthly_day,
						start_time: this.start_time,
						end_time: this.end_time,
						frequency: this.monthly_frequency,
					});
					this.start_time = "";
					this.end_time = "";
					this.monthly_day = "";
					this.monthly_frequency = "";
					break;
				case 5:
					this.$set(this.tableData_range, idx, {
						srno: idx + 1,
						from_score: this.from_score,
						to_score: this.to_score,
						grade: this.grade,
						editing: false,
					});
					for (let i = 0; i < this.gradeItems.length; i++) {
						let itemDisabled = false;

						for (let j = 0; j < this.tableData_range.length; j++) {
							if (
								this.tableData_range[j].grade &&
								this.tableData_range[j].grade.includes(this.gradeItems[i].value)
							) {
								itemDisabled = true;
								break;
							}
						}
						this.$set(this.gradeItems, i, {
							...this.gradeItems[i],
							disabled: itemDisabled,
						});
					}
					this.from_score = "";
					this.to_score = "";
					this.grade = "";
					console.log(this.tableData_range, "this.tableData_range");
					this.$forceUpdate();
					break;
				case 200:
					this.tableData_daily_radio.push({
						start_time_selection: "1",
						end_time_selection: "1",
						srno_selection: "1",
					});
					break;
				case 300:
					this.tableData_weekly_radio.push({
						day_selection: "1",
						frequency_selection: "1",
						start_time_selection: "1",
						end_time_selection: "1",
						srno_selection: "1",
					});
					break;
				case 400:
					this.tableData_monthly_radio.push({
						day_selection: "1",
						frequency_selection: "1",
						start_time_selection: "1",
						end_time_selection: "1",
						srno_selection: "1",
					});
					break;
				case 500:
					this.from_score = "";
					this.to_score = "";
					this.grade = "";
					this.tableData_range.push({
						// from_score_selection: "1",
						srno_selection: "1",
					});
					break;
				default:
					break;
			}
		},
		toggle_actions_cancel_button(value, idx, item) {
			console.log(value, idx, item, "value, idx,item");
			switch (value) {
				case 5:
					if (!this.from_score && !this.to_score && !this.grade) {
						this.tableData_range.splice(idx, 1);
					} else {
						this.$set(this.tableData_range, idx, {
							srno: idx + 1,
							from_score: this.from_score,
							to_score: this.to_score,
							grade: this.grade,
							editing: false,
						});
					}
					break;

				default:
					break;
			}
		},
		toggle_actions_edit(idx, item, action, value) {
			this.category = "";
			if (action == "EDIT" && value == 1) {
				this.tableEditing = true;
				console.log(item, "edit");
				this.tableData.splice(idx, 1, { editing: true });
				this.critical = item.critical;
				this.allowedOn = item.allowedon;
				this.category = item.category_id;
				this.form = item.form;
				this.tableData[idx].points = item.points;
				this.tableData[idx].srno = item.srno;
				this.tableData[idx].form_length = item.form_length;
				this.list_forms();
				console.log(this.tableData[idx], "here");
				this.editing_item = item;

				this.$forceUpdate();
			}
			if (action == "EDIT" && value == 2) {
				console.log("item", item);
				console.log(this.tableData_daily_radio, "this.tableData_daily_radio");
				this.tableData_daily_radio.splice(idx, 1, { editing: true });
				this.start_time = item.start_time;
				this.end_time = item.end_time;
			}
			if (action == "EDIT" && value == 3) {
				console.log("item", item);
				console.log(this.tableData_weekly_radio, "this.tableData_daily_radio");
				this.tableData_weekly_radio.splice(idx, 1, { editing: true });
				this.start_time = item.start_time;
				this.end_time = item.end_time;
				this.weekly_day = item.day;
				this.weekly_frequency = item.frequency;
			}
			if (action == "EDIT" && value == 4) {
				console.log("item", item);
				console.log(this.tableData_monthly_radio, "this.tableData_daily_radio");
				this.tableData_monthly_radio.splice(idx, 1, { editing: true });
				this.start_time = item.start_time;
				this.end_time = item.end_time;
				this.monthly_day = item.day;
				this.monthly_frequency = item.frequency;
			}
			if (action == "EDIT" && value == 5) {
				console.log("item", item);
				console.log(this.tableData_range, "this.tableData_daily_radio");
				this.tableData_range.splice(idx, 1, { editing: true, srno: idx + 1 });
				this.from_score = item.from_score;
				this.to_score = item.to_score;
				this.grade = item.grade;
				for (let i = 0; i < this.gradeItems.length; i++) {
					this.gradeItems[i].disabled = false;
				}
				let items = [];
				for (let i = 0; i < this.from_scoreItemsNew.length; i++) {
					items.push(this.from_scoreItemsNew[i]);
				}
				this.from_scoreItems = items;
			}
			this.$forceUpdate();
		},
		toggle_actions_cancel(idx, item, action, value) {
			console.log(idx, item, action, value, "idx, item, action, value");
			if (!item.allowed_on_selection) {
				this.tableData[idx] = [];
				let category = "";
				let category_id = "";
				this.categoryItems.filter((el) => {
					if (el.id == this.editing_item.category_id) {
						category = el.name;
						category_id = el.id;
					}
				});
				console.log(this.editing_item, "ee");
				this.tableData[idx].form_length = this.editing_item.form_length;
				this.tableData[idx].srno = this.editing_item.srno;
				this.tableData[idx].category = category;
				this.tableData[idx].category_id = category_id;
				this.tableData[idx].form = this.editing_item.form;
				this.tableData[idx].critical = this.editing_item.critical;
				this.tableData[idx].allowedon = this.editing_item.allowedon;
				this.tableData[idx].points = this.editing_item.points;
				this.tableData[idx].editable_icon = this.editing_item.editable_icon;
				this.tableData[idx].showEditIcon = this.editing_item.showEditIcon;
				this.tableData[idx].showDropdown = false;
				this.tableData[idx].editing = false;
				this.tableEditing = false;
				setTimeout(() => {
					const total = this.getTotal;
					this.getPoints;
					console.log(total, "total");
				}, 100);
				this.$forceUpdate();
			} else {
				this.tableData.splice(idx, 1);
				this.tableEditing = false;
			}
		},
		toggle_actions(idx, item, action, value) {
			switch (value) {
				case 1:
					this.tableData.splice(idx, 1);
					if (this.tableData.length == 0) {
						this.tableData.push({
							category_selection: "1",
							form_selection: "1",
							critical_selection: "1",
							allowed_on_selection: "1",
							srno_selection: "1",
						});
					}
					for (let i = 0; i < this.tableData.length; i++) {
						this.tableData[i].srno = i + 1;
					}
					break;
				case 2:
					this.tableData_daily_radio.splice(idx, 1);
					if (this.tableData_daily_radio.length == 0) {
						this.tableData_daily_radio.push({
							start_time_selection: "1",
							end_time_selection: "1",
							srno_selection: "1",
						});
					}
					for (let i = 0; i < this.tableData_daily_radio.length; i++) {
						this.tableData_daily_radio[i].srno = i + 1;
					}
					break;
				case 3:
					this.tableData_weekly_radio.splice(idx, 1);
					if (this.tableData_weekly_radio.length == 0) {
						this.tableData_weekly_radio.push({
							day_selection: "1",
							frequency_selection: "1",
							start_time_selection: "1",
							end_time_selection: "1",
							srno_selection: "1",
						});
					}
					for (let i = 0; i < this.tableData_weekly_radio.length; i++) {
						this.tableData_weekly_radio[i].srno = i + 1;
					}

					break;
				case 4:
					this.tableData_monthly_radio.splice(idx, 1);
					if (this.tableData_monthly_radio.length == 0) {
						this.tableData_monthly_radio.push({
							day_selection: "1",
							frequency_selection: "1",
							start_time_selection: "1",
							end_time_selection: "1",
							srno_selection: "1",
						});
					}
					for (let i = 0; i < this.tableData_monthly_radio.length; i++) {
						this.tableData_monthly_radio[i].srno = i + 1;
					}

					break;
				case 5:
					console.log(this.tableData_range, "this.tableData_range bef");
					this.tableData_range.splice(idx, 1);
					console.log(this.tableData_range, "this.tableData_range aft");
					if (this.tableData_range.length == 0) {
						this.tableData_range.push({
							from_score_selection: "1",
							srno_selection: "1",
						});
					}
					for (let i = 0; i < this.tableData_range.length; i++) {
						this.tableData_range[i].srno = i + 1;
					}
					if (this.tableData_range[0].from_score_selection == "1") {
						let items = [];
						let score = 0;
						for (let i = score; i < this.from_scoreItemsNew.length; i++) {
							items.push(this.from_scoreItemsNew[i]);
						}
						for (let i = 0; i < this.gradeItems.length; i++) {
							this.gradeItems[i].disabled = false;
						}
						this.from_scoreItems = items;
					} else {
						let score = 0;
						score =
							this.tableData_range[this.tableData_range.length - 1].to_score;
						let items = [];
						console.log(this.tableData_range, "this.tableData_range");
						for (let i = score; i < this.from_scoreItemsNew.length; i++) {
							items.push(this.from_scoreItemsNew[i]);
						}
						for (let i = 0; i < this.gradeItems.length; i++) {
							for (let j = 0; j < this.tableData_range.length; j++) {
								if (
									this.tableData_range[j].grade.includes(
										this.gradeItems[i].value
									)
								) {
									this.gradeItems[i].disabled = true;
								} else {
									this.gradeItems[i].disabled = false;
								}
							}
						}
						this.from_scoreItems = items;
					}

				default:
					break;
			}
			this.$forceUpdate();
		},
		list_forms() {
			formBuilderServices.listFormsByCategoryId(this.category).then((res) => {
				this.formItems = JSON.parse(res.data);
				this.formItems.unshift({ name: "All", id: "All" });
				console.log("this.formItems", this.formItems);
			});
		},
		list_all_categories() {
			formBuilderServices.listAllCategory().then((res) => {
				this.categoryItems = JSON.parse(res.data);
				console.log(this.categoryItems, "rrrr");
			});
		},
		nextStep(val) {
			let error = false;
			if (val == 1) {
				for (let i = 0; i < this.tableData.length; i++) {
					if (
						this.tableData[i].category_selection ||
						this.tableData[i].form_selection ||
						this.tableData[i].allowed_on_selection
					) {
						error = true;
					}
				}
				if (error) alert("Add at least 1 Category");
			}
			if (val == 3) {
				if (this.grades_radio == "1") {
					console.log(this.tableData_range[0]);
					if (this.tableData_range[0].from_score_selection) {
						alert("Select Range Table");
						error = true;
					}
				}
			}
			// if (val == 4) {
			// 	console.log(
			// 		new Date(this.before_start * 60 * 1000).toISOString().substr(11, 8),
			// 		"asdasdsadaf"
			// 	);
			// }
			if (!error) {
				this.$validator.validateAll().then((result) => {
					if (result) {
						for (let i = 0; i < this.createProjectItems.length; i++) {
							this.createProjectItems[i].active = false;
						}
						this.createProjectItems[val].active = true;
					} else {
						alert("Enter required fields");
					}
				});
			}
		},
	},
};
</script>

<style lang="scss">
.create_project {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.project-table00 {
		tbody tr td {
			text-align: left !important;
		}
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow: hidden;
			position: relative;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
	.project-table01 {
		tbody tr td {
			text-align: left !important;
		}
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow: hidden;
			position: relative;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
	.project-table {
		tbody tr td {
			text-align: center !important;
		}
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		.el-table th.el-table__cell > .cell {
			text-align: center !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: center !important;
		}
		.el-table__body-wrapper {
			overflow: hidden;
			position: relative;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
	.project-table9 {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;

		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
		}
		.el-table__body-wrapper {
			overflow: hidden;
			position: relative;
		}
	}
	.project-table2 {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;

		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
		}
		.el-table__empty-block {
			display: none !important;
		}
	}
	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 100%;
	}
}
</style>
